<template>

    <div>

        <!--        <v-row class="px-3 my-1">
                    <v-col class="text-left" cols="12" md="8">
                        <div class="text-h5">
                            Internet Filter
                        </div>
                        <div class="subtitle-1 text-left mb-4">
                            Control access to the internet by creating rules based on users, domains, days, and times.
                        </div>
                    </v-col>
                    <v-col cols="12" md="4">
                        <div class="d-flex justify-end">
                            <v-text-field
                                ref="ruleSearch"
                                append-icon="mdi-magnify"
                                v-model="ruleFilterValue"
                                label="Narrow down rules"
                                clearable
                                v-if="isShowSearch && hideMobileListingForMobileIfListingItemSelected()"
                                class="search-listing-autocomplete max-width-450"
                            ></v-text-field>

                            <v-btn-toggle class="pr-2 my-1 ml-3 ">
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiMagnify"></v-icon>
                                </v-btn>
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiFilter"></v-icon>
                                </v-btn>
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiAccountPlus"></v-icon>
                                </v-btn>
                            </v-btn-toggle>

                        </div>

                    </v-col>
                </v-row>-->

        <!--        <v-divider class="my-1"></v-divider>-->

        <!-- Do not remove this mt-1 otherwise there's a small cut when navigateToRule function is called from the users tab -->
        <v-row class="mt-1">

            <!--            <v-col :cols="currentSelectedRuleKey ? (ruleCompact ? 1 : 3) : 12">-->
            <v-col :cols="currentSelectedRuleKey ? (ruleCompact ? 12 : 12) : 12"
                   :lg="currentSelectedRuleKey ? (ruleCompact ? 2 : 4) : 12"
                   :md="currentSelectedRuleKey ? (ruleCompact ? 3 : 6) : 12"
                   :xl="currentSelectedRuleKey ? (ruleCompact ? 2 : 3) : 12" class="border-right-divider">
                <!--                <v-icon class="my-2 mr-1" @click="showSearch()" v-if="!isShowSearch">
                                    {{ icons.mdiMagnify }}
                                </v-icon>-->

                <!--                    style="max-width: 300px;"-->
                <!--                :autofocus="$vuetify.breakpoint.smAndDown"-->

                <!--Works but we don't want to narrow down to a single rule anymore, one bug was if second item from the list is selected (dy), if this every is used again. <v-autocomplete
                                    ref="ruleSearch"
                                    append-icon="mdi-magnify"
                                    v-model="ruleFilterValue"
                                    :items="rules"
                                    :item-text="'key'"
                                    :item-value="'key'"
                                    label="Narrow down to a Rule"
                                    clearable
                                    v-if="isShowSearch && hideMobileListingForMobileIfListingItemSelected()"
                                    class="search-listing-autocomplete"
                                ></v-autocomplete>-->
                <v-row>
                    <v-col :cols="ruleCompact  ? 9 : 6" :md="ruleCompact  ? 9 : 7" class="pb-0 mb-0">

                        <!--                        <v-text-field
                                                    ref="ruleSearch"
                                                    append-icon="mdi-magnify"
                                                    v-model="ruleFilterValue"
                                                    :label="$gettext('Search rules')"
                                                    clearable
                                                    v-if="hideMobileListingForMobileIfListingItemSelected() && rules.length > 0"
                                                    class="search-listing-autocomplete"
                                                    hide-details
                                                ></v-text-field>-->


                        <div
                            v-if="haveUsers || (userAutoCompleteFilterValue2 && userAutoCompleteFilterValue2.length > 0)"
                            cols="10"
                            md="11">

                            <!-- have a slot for hint/persistent hint -->
                            <v-autocomplete
                                v-if="hideMobileListingForMobileIfListingItemSelected() && rules.length > 0"
                                ref="userSearch"
                                v-model="userAutoCompleteFilterValue2"
                                :items="consolidatedUsersAndSubUsers"
                                :label="$gettext('Search users')"
                                append-icon="mdi-magnify"
                                clearable
                                hide-details
                            ></v-autocomplete>
                            <div class="caption mt-1 text-left cursor-pointer" @click="toggleShowMoreSearchFields()">
                                <span v-if="!showMoreSearchFields"><v-icon small v-text="icons.mdiPlus"></v-icon> {{
                                        $gettext('Show more search options')
                                    }}</span>
                                <span v-else><v-icon small v-text="icons.mdiMinus"></v-icon>{{
                                        $gettext('Show less search options')
                                    }}</span>
                            </div>

                            <!--
                            <v-autocomplete
                                                ref="userSearch"
                                                append-icon="mdi-magnify"
                                                v-model="userAutoCompleteFilterValue2"
                                                :items="prepareAnArrayForAutocompleteTopLevel(users)"
                                                label="Narrow down to a User"
                                                clearable
                                            ></v-autocomplete>
                                            -->

                        </div>


                    </v-col>
                    <v-col :class="{'mt-2': $vuetify.breakpoint.smAndDown}" :cols="ruleCompact ? 3: 6"
                           :md="ruleCompact ? 3: 5"
                           class="text-right align-center justify-center text-right pb-0 mb-0">

                        <!------------------------------------------------
                            Filter Buttons
                        ------------------------------------------------->

                        <v-btn-toggle v-if="isMdAndUpOrOnTheMobileListingPage" :dense="$vuetify.breakpoint.smAndDown">

                            <v-btn v-if="!ruleCompact" icon plain @click="openAddEditRuleDialog('', 'add')">
                                <v-icon v-text="icons.mdiPlus"></v-icon>
                            </v-btn>
                            <v-menu v-if="!ruleCompact">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon plain v-bind="attrs" v-on="on">
                                        <v-icon
                                            v-text="ruleFilterConditions?.length > 0 ? icons.mdiFilter : icons.mdiFilterOff"></v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item class="cursor-pointer"
                                                 @click="pushAFilterRule({'active': 'on'}, 'active')">
                                        <v-list-item-title>
                                            <v-btn class="mr-1" icon>
                                                <v-icon :color="isDark? 'success' : 'secondary'"
                                                        size="40"
                                                        v-text="icons.mdiCircleSmall"></v-icon>
                                            </v-btn>
                                            {{ $gettext('Active') }}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor-pointer"
                                                 @click="pushAFilterRule({'active': 'off'}, 'inactive')">
                                        <v-list-item-title>
                                            <v-btn class="mr-1" icon>
                                                <v-icon color="grey" size="40" v-text="icons.mdiCircleSmall"></v-icon>
                                            </v-btn>
                                            {{ $gettext('Inactive') }}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor-pointer" @click="pushAFilterRule(false, 'all')">
                                        <v-list-item-title>
                                            <v-btn class="mr-1" icon>
                                                <v-icon class="mr-1" size="18" v-text="icons.mdiFilterOff"></v-icon>
                                            </v-btn>
                                            {{ $gettext('All') }}
                                        </v-list-item-title>
                                    </v-list-item>

                                </v-list>
                            </v-menu>

                            <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :class="{'mt-4': ruleCompact}" :dense="ruleCompact" :small="ruleCompact" icon
                                           plain v-bind="attrs"
                                           v-on="on">
                                        <v-icon v-text="icons.mdiDotsVertical"></v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item v-if="ruleCompact" class="cursor-pointer"
                                                 @click="openAddEditRuleDialog('', 'add')">
                                        <v-list-item-title>
                                            <v-btn class="mr-1" icon>
                                                <v-icon small v-text="icons.mdiPlus"></v-icon>
                                            </v-btn>
                                            <span v-text="$gettext('Add Rule')"></span>
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-menu v-if="ruleCompact">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-list-item v-if="ruleCompact" class="cursor-pointer" v-bind="attrs"
                                                         v-on="on">
                                                <v-list-item-title>
                                                    <v-btn class="mr-1" icon>
                                                        <v-icon
                                                            small
                                                            v-text="(ruleFilterConditions?.length > 0) ? icons.mdiFilter : icons.mdiFilterOff"></v-icon>
                                                    </v-btn>
                                                    <span v-text="$gettext('Filter')"></span>
                                                </v-list-item-title>
                                            </v-list-item>
                                        </template>
                                        <v-list dense>
                                            <v-list-item class="cursor-pointer"
                                                         @click="pushAFilterRule({'active': 'on'}, 'active')">
                                                <v-list-item-title>
                                                    <v-btn class="mr-1" icon>
                                                        <v-icon :title="$gettext('Active')" color="secondary"
                                                                size="40" v-text="icons.mdiCircleSmall"></v-icon>
                                                    </v-btn>
                                                    {{ $gettext('Active') }}
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item class="cursor-pointer"
                                                         @click="pushAFilterRule({'active': 'off'}, 'inactive')">
                                                <v-list-item-title>
                                                    <v-btn class="mr-1" icon>
                                                        <v-icon :title="$gettext('Inactive')" color="grey" size="40"
                                                                v-text="icons.mdiCircleSmall"></v-icon>
                                                    </v-btn>
                                                    {{ $gettext('Inactive') }}
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item class="cursor-pointer" @click="pushAFilterRule(false, 'all')">
                                                <v-list-item-title>
                                                    <v-btn class="mr-1" icon>
                                                        <v-icon :title="$gettext('All')" class="mr-1" size="18" small
                                                                v-text="icons.mdiFilterOff"></v-icon>
                                                    </v-btn>
                                                    {{ $gettext('All') }}
                                                </v-list-item-title>
                                            </v-list-item>

                                        </v-list>
                                    </v-menu>

                                    <v-list-item v-if="currentSelectedRule && $vuetify.breakpoint.lgAndUp"
                                                 class="cursor-pointer"
                                                 @click="toggleLayout()">
                                        <v-list-item-title>
                                            <v-btn class="mr-1" icon>
                                                <v-icon v-if="layout === 'column'" small
                                                        v-text="icons.mdiSwapVertical"></v-icon>
                                                <v-icon v-else small v-text="icons.mdiSwapHorizontal"></v-icon>
                                            </v-btn>
                                            <span v-text="$gettext('Switch Layout')"></span>
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item class="cursor-pointer">
                                        <v-list-item-title>
                                            <v-tooltip bottom color="primary">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="mr-1" icon v-bind="attrs" v-on="on">
                                                        <v-icon class="my-2 mr-1" small
                                                                v-text="icons.mdiHeadQuestion"></v-icon>
                                                    </v-btn>
                                                    <span v-bind="attrs" v-on="on"
                                                          v-text="$gettext('Learn Colours')"></span>
                                                </template>

                                                <div class="white-background">
                                                    <div class="orange--text" v-text="$gettext('Deny + Listing')"></div>
                                                    <div class="red--text" v-text="$gettext('Deny + All')"></div>
                                                    <div class="green--text" v-text="$gettext('Allowed')"></div>
                                                    <!--                                                    <div class="blue&#45;&#45;text text&#45;&#45;lighten-1"-->
                                                    <!--                                                         v-text="$gettext('Managed by organization')"></div>-->
                                                    <div class="font-weight-normal"
                                                         v-text="$gettext('Normal text applies to selected/listing users')"></div>
                                                    <div class="font-weight-black"
                                                         v-text="$gettext('Bold text applies to all users')"></div>
                                                </div>
                                            </v-tooltip>
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item v-if="currentSelectedRuleKey" class="cursor-pointer">
                                        <v-list-item-title @click="markRuleCompact(!ruleCompact)">

                                            <v-btn v-show="!ruleCompact" class="mr-1" icon>
                                                <v-icon small v-text="icons.mdiChevronLeftCircle"></v-icon>
                                            </v-btn>

                                            <v-btn v-if="currentSelectedRuleKey" v-show="ruleCompact" class="mr-1" icon>
                                                <v-icon small v-text="icons.mdiChevronRightCircle"></v-icon>
                                            </v-btn>

                                            <span v-if="!ruleCompact" v-text="$gettext('Compact')"></span>
                                            <span v-else v-text="$gettext('Expand')"></span>

                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>


                            <!--                            <v-btn icon @click="toggleLayout()" v-if="currentSelectedRuleKey">
                                                            <v-icon v-if="layout === 'column'">
                                                                {{ icons.mdiSwapVertical }}
                                                            </v-icon>
                                                            <v-icon v-else>
                                                                {{ icons.mdiSwapHorizontal }}
                                                            </v-icon>
                                                        </v-btn>
                                                        <v-btn icon v-show="!ruleCompact" @click="markRuleCompact(true)" v-if="currentSelectedRuleKey">
                                                            <v-icon v-text="icons.mdiChevronLeftCircle"></v-icon>
                                                        </v-btn>

                                                        <v-btn icon v-show="ruleCompact" @click="markRuleCompact(false)" v-if="currentSelectedRuleKey">
                                                            <v-icon v-text="icons.mdiChevronRightCircle"></v-icon>
                                                        </v-btn>

                                                        -->


                        </v-btn-toggle>


                    </v-col>
                </v-row>

                <v-row v-if="showMoreSearchFields">
                    <v-col class="mt-0 pt-0 mb-0" cols="12" md="6">
                        <v-text-field
                            v-if="hideMobileListingForMobileIfListingItemSelected() && rules.length > 0"
                            ref="ruleSearch"
                            v-model="ruleFilterValue"
                            :label="$gettext('Search rules')"
                            append-icon="mdi-magnify"
                            class="search-listing-autocomplete"
                            clearable
                            hide-details
                            @change="setVisibleRules()"
                        ></v-text-field>
                    </v-col>
                    <v-col class="mt-0 pt-0 mb-0" cols="12" md="6">
                        <v-autocomplete
                            v-if="hideMobileListingForMobileIfListingItemSelected() && rules.length > 0"
                            ref="userSearch"
                            v-model="domainFilter"
                            :items="allDomainsForVisibleRules"
                            :label="$gettext('Search domains')"
                            append-icon="mdi-magnify"
                            clearable
                            hide-details
                        >
                        </v-autocomplete>
                    </v-col>
                </v-row>

                <v-divider v-if="isMdAndUpOrOnTheMobileListingPage" class="mt-6 mb-2"></v-divider>

                <v-list v-if="currentViewRulesCount() > 0"
                        v-show="hideMobileListingForMobileIfListingItemSelected()"
                        :class="{'mb-12': $vuetify.breakpoint.smAndDown}"
                        class="v-list-wrapper internet-filter-list-item">

                    <v-list-item-group
                        v-model="rulesListItem"
                        color="primary"
                    >
                        <draggable v-model="rules" :options="{disabled : $vuetify.breakpoint.smAndDown}">
                            <transition-group>

                                <!-- otherwise on the second tap active class is lost -->
                                <v-list-item
                                    v-for="(rule) in rules"
                                    v-show="ruleSelectedForMobile() && checkEachRule(rule)"
                                    :key="rule.key"
                                    :ref="'rule-'+rule.key"
                                    :class="{ 'v-item--active v-list-item--active v-list-item-active' : currentSelectedRuleKey === rule.key }"
                                    :value="rule.key"
                                    class="pl-0 pr-0"
                                    ripple
                                    @click="selectRule(rule.key, rule.value)"
                                >
                                    <v-list-item-title
                                        :class="{'add-border-list-on-small-devices': $vuetify.breakpoint.xsOnly}"
                                        class="text-left">
                                        <v-hover v-slot="{ hover }">
                                            <v-row>
                                                <!--                                                <v-col cols="1" md="1" sm="2" class="align-flex-start pl-5 pt-0">-->
                                                <v-col
                                                    :class="{'pl-4 pt-0 pb-0': $vuetify.breakpoint.xsOnly, 'py-0': $vuetify.breakpoint.smAndUp && !ruleCompact}"
                                                    :md="ruleCompact ? 12 : 7"
                                                    class="body-2 text-truncate align-flex-start"
                                                    cols="9"
                                                    sm="7">

                                                    <!--                                                        :icon="icons.mdiFilterVariant"-->


                                                    <!--                                                        <v-badge
                                                                                                                v-if="rule && rule.hasOwnProperty('value') && rule.value && rule.value.hasOwnProperty('allow_deny') && rule.value.allow_deny === 1"
                                                                                                                bordered
                                                                                                                inline
                                                                                                                dot
                                                                                                                color="secondary"
                                                                                                                @click.native.stop="toggleAllowDeny(rule.value)"
                                                                                                                class="ml-0"
                                                                                                                v-show="!ruleCompact"
                                                                                                            >
                                                                                                            </v-badge>
                                                                                                            <v-badge
                                                                                                                v-else
                                                                                                                inline
                                                                                                                dot
                                                                                                                @click.native.stop="toggleAllowDeny(rule.value)"
                                                                                                                color="grey"
                                                                                                                class="ml-0"
                                                                                                                v-show="!ruleCompact"
                                                                                                            >
                                                                                                            </v-badge>-->


                                                    <v-btn
                                                        :color="rule.value.any_user === 1 ? 'primary' : 'grey lighten-2'"
                                                        fab icon
                                                        x-small
                                                    >
                                                        <v-icon v-if="rule.value.any_user === 1" class="mr-1"
                                                                color="primary" size="18"
                                                                @click="toggleAnyUser(rule.value)"
                                                                v-text="icons.mdiAccountMultipleCheck"></v-icon>
                                                        <v-icon v-else class="mr-1" size="18"
                                                                @click="toggleAnyUser(rule.value)"
                                                                v-text="icons.mdiAccountCancel"></v-icon>
                                                    </v-btn>

                                                    <v-btn
                                                        :color="rule?.value?.any_destination === 1 ? 'primary' : 'grey lighten-2'"
                                                        fab icon
                                                        x-small
                                                    >
                                                        <v-icon v-if="rule?.value?.any_destination === 1" class="mr-1"
                                                                color="primary"
                                                                size="18" @click="toggleAnyDestination(rule.value)"
                                                                v-text="icons.mdiWebPlus"></v-icon>
                                                        <v-icon v-else class="mr-1"
                                                                size="18" @click="toggleAnyDestination(rule.value)"
                                                                v-text="icons.mdiWebMinus"></v-icon>
                                                    </v-btn>
                                                    <span :class="ruleTextColorClasses(rule)"
                                                          class="pl-2 text-truncate rule-name" v-text="rule.key"></span>
                                                    <icons-master v-if="ruleIsMaster(rule)"
                                                                  :title="$gettext('This rule is managed by organization')"></icons-master>
                                                    <!-- to be deleted, created as a sample ui
                                                  <span style="max-width: 60px; max-height: 60px" v-if="rule.key === 'general permissions'">
                                                                                        <v-icon x-small color="primary">
                                                                                            mdi-clock-outline
                                                                                        </v-icon>
                                                                                    <v-avatar size="16">
                                                                                        <span class="user-count">6</span>
                                                                                    </v-avatar>
                                                                                </span>-->
                                                </v-col>
                                                <v-col v-show="!ruleCompact"
                                                       :class="{'align-flex-end pt-0' : $vuetify.breakpoint.xsOnly,'align-flex-end': $vuetify.breakpoint.smAndUp}"
                                                       class="pr-4 ml-auto" cols="3"
                                                       md="5"
                                                       sm="5">
                                                    <v-btn class="ml-4" icon x-small>
                                                        <v-checkbox
                                                            v-show="!ruleCompact"
                                                            v-model="rule && rule.value && rule.value.active"
                                                            :false-value="'off'"
                                                            :true-value="'on'"
                                                            class="pt-0 pb-2 rule-checkbox"
                                                            hide-details
                                                        ></v-checkbox>
                                                    </v-btn>
                                                    <v-menu>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                <v-icon v-text="icons.mdiDotsVertical"></v-icon>
                                                            </v-btn>
                                                        </template>


                                                        <v-list dense>
                                                            <v-list-item
                                                                @click="openAddEditRuleDialog(rule.key, 'edit')">
                                                                <v-list-item-title>
                                                                    <v-icon class="mr-2" size="18"
                                                                            v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                    {{ $gettext('Edit') }}
                                                                </v-list-item-title>
                                                            </v-list-item>
                                                            <v-list-item @click="deleteRule(rule.key)">
                                                                <v-list-item-title>
                                                                    <v-icon class="mr-2" size="18"
                                                                            v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                    {{ $gettext('Delete') }}
                                                                </v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>

                                                    <!--                                                    <v-icon class="mr-1" v-if="hover || $vuetify.breakpoint.smAndDown" @click.native.stop="openAddEditRuleDialog(rule.key, 'edit')" size="18">
                                                                                                            {{ icons.mdiPencil }}
                                                                                                        </v-icon>
                                                                                                        <v-icon class="mr-1" v-if="hover || $vuetify.breakpoint.smAndDown" @click.native.stop="deleteRule(rule.key)" size="18">
                                                                                                            {{ icons.mdiDeleteForever }}
                                                                                                        </v-icon>-->

                                                    <!--                                                    <v-icon v-if="rule.value.allow_deny === 1" class="mr-1" @click.native.stop="toggleAllowDeny(rule.value)" color="primary">{{
                                                                                                                icons.mdiWebCheck
                                                                                                            }}
                                                                                                        </v-icon>
                                                                                                        <v-icon v-else class="mr-1" @click.native.stop="toggleAllowDeny(rule.value)">{{
                                                                                                                icons.mdiWebCancel
                                                                                                            }}
                                                                                                        </v-icon>-->
                                                </v-col>

                                            </v-row>

                                        </v-hover>
                                    </v-list-item-title>

                                    <!--                            <v-list-item-subtitle v-show="!currentSelectedRuleKey">
                                                                    Description
                                                                </v-list-item-subtitle>-->

                                </v-list-item>

                            </transition-group>

                        </draggable>

                    </v-list-item-group>
                </v-list>
                <v-row
                    v-else-if="userAutoCompleteFilterValue2.length > 0 || domainFilter.length > 0 || ruleFilterValue.length > 0"
                    class="mx-1 my-4">
                    <v-col>

                        <!-- We are not including domainFilter here in condition because, being an autocomplete, it will only be present if some domain value is there. i.e if there is a domain filter, we will have a row -->

                        <rules-no-matching-search-result
                            :filter-text="userAutoCompleteFilterValue2 || ruleFilterValue"></rules-no-matching-search-result>

                    </v-col>
                </v-row>
                <v-row v-else class="mx-1 my-4">
                    <v-col>{{ $gettext('We don\'t have any rules added yet.') }} <a
                        v-text="$gettext('Add one')" @click.prevent="openAddEditRuleDialog('', 'add')"></a>.
                    </v-col>
                </v-row>

                <v-divider v-if="isMdAndUpOrOnTheMobileListingPage" class="mb-2"></v-divider>
                <!--                <v-bottom-navigation
                                    :value="1"
                                    color="secondary"
                                    v-if="isShowFilter && !ruleCompact && $vuetify.breakpoint.mdAndUp"
                                >

                                    <v-btn @click="pushAFilterRule({'active': 'on'}, 'active')" :class="{'v-btn-active': currentFilterMode === 'active'}">
                                        <span>Active</span>

                                        <v-icon class="my-2 mr-1" small>
                                            {{ icons.mdiFilterCheck }}
                                        </v-icon>
                                    </v-btn>
                                    <v-btn @click="pushAFilterRule(false, 'all')" :class="{'v-btn-active': currentFilterMode === 'all'}">
                                        <span>All</span>

                                        <v-icon class="my-2 mr-1" small>
                                            {{ icons.mdiFilterOff }}
                                        </v-icon>
                                    </v-btn>
                                    <v-btn @click="pushAFilterRule({'active': 'off'}, 'inactive')" :class="{'v-btn-active': currentFilterMode === 'inactive'}">
                                        <span>Inactive</span>

                                        <v-icon class="my-2 mr-1" small>
                                            {{ icons.mdiFilter }}
                                        </v-icon>
                                    </v-btn>


                                </v-bottom-navigation>-->


                <!--                <v-bottom-navigation
                                    :value="1"
                                    color="secondary"
                                    v-if="$vuetify.breakpoint.mdAndUp"
                                >

                                    <v-btn @click="toggleFilter()" v-show="!ruleCompact" :input-value="isShowFilter ? 1: 0">
                                        <span v-if="isShowFilter">Hide Filter</span>
                                        <span v-else>Filter</span>

                                        <v-icon class="my-2 mr-1" small>
                                            {{ icons.mdiFilter }}
                                        </v-icon>
                                    </v-btn>

                                    <v-btn @click="openAddEditRuleDialog('', 'add')">
                                        <span>Add Rule</span>

                                        <v-icon class="my-2 mr-1" small>
                                            {{ icons.mdiAccountPlus }}
                                        </v-icon>
                                    </v-btn>
                                    <v-btn @click="toggleLayout()" v-if="currentSelectedRuleKey">
                                        <span>Layout</span>

                                        <v-icon class="my-2 mr-1" v-if="layout === 'column'" small>
                                            {{ icons.mdiSwapVertical }}
                                        </v-icon>
                                        <v-icon v-else class="my-2 mr-1" small>
                                            {{ icons.mdiSwapHorizontal }}
                                        </v-icon>
                                    </v-btn>

                                    <v-btn v-show="!ruleCompact" @click="markRuleCompact(true)" v-if="currentSelectedRuleKey">
                                        <span>Compact</span>

                                        <v-icon class="my-2 mr-1" small>
                                            {{ icons.mdiChevronLeftCircle }}
                                        </v-icon>
                                    </v-btn>

                                    <v-btn v-show="ruleCompact" @click="markRuleCompact(false)" v-if="currentSelectedRuleKey">
                                        <span>Expand</span>

                                        <v-icon class="my-2 mr-1" small>
                                            {{ icons.mdiChevronRightCircle }}
                                        </v-icon>
                                    </v-btn>

                                    <v-tooltip bottom color="primary">
                                        <template v-slot:activator="{ on, attrs }">

                                            <v-btn v-show="!ruleCompact" @click="markRuleCompact(false)" v-bind="attrs"
                                                   v-on="on">
                                                <span>Learn Colours</span>

                                                <v-icon class="my-2 mr-1" small>
                                                    {{ icons.mdiHeadQuestion }}
                                                </v-icon>
                                            </v-btn>
                                        </template>

                                        <div class="white-background">
                                            <div class="orange-text">Deny + Listing</div>
                                            <div class="red-text">Deny + All</div>
                                            <div class="green-text">Allowed</div>
                                            <div class="font-weight-normal">Normal text applies to selected/listing users</div>
                                            <div class="font-weight-black">Bold text applies to all users</div>
                                        </div>


                                    </v-tooltip>

                                </v-bottom-navigation>-->

            </v-col>
            <v-col v-show="currentSelectedRuleKey" :class="{'px-2': $vuetify.breakpoint.smAndDown}">
                <!--                <div class="display-1">{{ currentSelectedRuleKey }}</div>-->
                <!--                <v-alert
                                    border="left"
                                    class="internet-filter-content-header-block"
                                >
                                    <div class="display-1 text-capitalize">{{ currentSelectedRuleKey }}</div>
                                </v-alert>-->


                <v-card class="mb-4 mx-1">

                    <!-- if we do not have px-4, the Users panel is clipped slightly from the right end, when in the column mode -->
                    <v-row :class="{'mb-12': $vuetify.breakpoint.smAndDown}" class="px-4">
                        <v-col :cols="layout === 'row' ? '12' : $vuetify.breakpoint.lgAndUp ? '6' : '12'">
                            <v-card :outlined="isDark" elevation="1">
                                <v-card-title class="text-truncate">
                                    <v-row>
                                        <v-col cols="9" md="10">
                                            <div class="text-h6 text-left text-truncate">
                                                {{
                                                    $gettextInterpolate($gettext('Permissions for %{ ruleName }'), {ruleName: currentSelectedRuleKey})
                                                }}

                                                <!--
                                                <v-badge
                                                                                            v-if="currentSelectedRule && currentSelectedRule.hasOwnProperty('allow_deny') && currentSelectedRule.allow_deny === 0"
                                                                                            bordered
                                                                                            inline
                                                                                            dot
                                                                                            color="red lighten&#45;&#45;2"
                                                                                            @click.native.stop="toggleAllowDeny(currentSelectedRule)"
                                                                                            class="ml-0 pr-1"
                                                                                        >
                                                                                        </v-badge>
                                                                                        <v-badge
                                                                                            v-else
                                                                                            inline
                                                                                            dot
                                                                                            @click.native.stop="toggleAllowDeny(currentSelectedRule)"
                                                                                            color="secondary"
                                                                                            class="ml-0 pr-1"
                                                                                        >
                                                                                        </v-badge>
                                                                                        -->
                                            </div>
                                            <div v-if="['1', 1].includes(currentSelectedRule.master)"
                                                 class="caption text-left w-100">
                                                <v-icon class="mr-2" x-small v-text="icons.mdiLock"></v-icon>
                                                Managed by Organization
                                            </div>
                                        </v-col>
                                        <v-col class="text-right" cols="3" md="2">
                                            <!--                                            <v-spacer></v-spacer>-->
                                            <v-menu>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn :class="{'mt-4': ruleCompact}" :dense="ruleCompact"
                                                           :small="ruleCompact" icon plain
                                                           v-bind="attrs" v-on="on">
                                                        <v-icon v-text="icons.mdiDotsVertical"></v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item
                                                        class="cursor-pointer"
                                                        @click.prevent.native="openAddEditTimeConditionDialog('add')">
                                                        <v-list-item-title>
                                                            <v-btn class="mr-1" icon>
                                                                <v-icon small v-text="icons.mdiPlus"></v-icon>
                                                            </v-btn>
                                                            <span v-text="$gettext('Add time condition')"></span>
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-subtitle class="text-left mt-0">
                                    <v-row>
                                        <v-col cols="6">
                                            <!--                                                      :label="currentSelectedRule.any_destination === 0 ? $gettext('Listing') : $gettext('All')"-->
                                            <v-switch v-model="currentSelectedRule.any_destination"
                                                      :class="{'o-60': !currentSelectedRule.any_destination }"
                                                      :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                      :false-value="0"
                                                      :label="$gettext('All Domains')"
                                                      :true-value="1"
                                                      class="mt-0 pt-0 font-weight-bold transition-ease-in-out"
                                            >
                                            </v-switch>
                                        </v-col>
                                        <v-col class="text-right" cols="6">
                                            <!-- intentional always dark mode -->

                                            <v-btn
                                                v-if="currentSelectedRuleHasAllowDeny1"
                                                :color="isDark ? 'success' : 'secondary'"
                                                :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                dark
                                                small
                                                @click.stop="toggleAllowDeny(currentSelectedRule)"
                                            >
                                                <!--                                                <v-badge
                                                                                                    bordered
                                                                                                    inline
                                                                                                    dot
                                                                                                    color="secondary"
                                                                                                    class="ml-0"
                                                                                                >
                                                                                                </v-badge>-->
                                                {{ $gettext('Allowed') }}
                                            </v-btn>

                                            <v-btn v-else :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                   class="white--text"
                                                   color="orange" small
                                                   @click.stop="toggleAllowDeny(currentSelectedRule)"
                                            >

                                                <!--                                                <v-badge
                                                                                                    inline
                                                                                                    dot
                                                                                                    color="red"
                                                                                                    class="ml-0"
                                                                                                >
                                                                                                </v-badge>-->
                                                {{ $gettext('Denied') }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>


                                </v-card-subtitle>
                                <v-card-text>

                                    <v-row>
                                        <v-col>


                                            <!--                                            <v-row class="align-flex-end">
                                                                                            <v-col cols="12" :class="{'text-right mr-4': $vuetify.breakpoint.smAndUp, 'mr-0 mr-md-8' : $vuetify.breakpoint.xsOnly}">

                                                                                                <v-btn class="secondary ml-3 lighten-2"
                                                                                                       rounded
                                                                                                       color="primary"
                                                                                                       @click.prevent.native="openAddEditTimeConditionDialog('add')"
                                                                                                >
                                                                                                    <v-icon v-text="icons.mdiTimerPlusOutline" title="Add a time condition"></v-icon>
                                                                                                </v-btn>
                                                                                            </v-col>
                                                                                        </v-row>-->

                                            <v-tabs-items v-model="currentSelectedRule.any_destination">
                                                <v-tab-item
                                                    v-if="currentSelectedRule"
                                                    :key="0"
                                                    :value="0"
                                                >
                                                    <v-card flat>
                                                        <v-card-text>
                                                            <div id="destDomainsWrapper">
                                                                <!--persistent-hint-->
                                                                <v-combobox
                                                                    id="destDomains"
                                                                    ref="destDomainsRef"
                                                                    v-model="currentSelectedRule.dest_domains"
                                                                    :class="{'mb-2': ruleCompact}"
                                                                    :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                                    :hide-details="ruleCompact"
                                                                    :hint="$gettext('Double tap a domain to edit it.')"
                                                                    :items="currentSelectedRule.dest_domains"
                                                                    :label="$gettext('Domains')"
                                                                    :menu-props="{  maxHeight: 200 }"
                                                                    :placeholder="$gettext('Domains')"
                                                                    :small-chips="ruleCompact"
                                                                    chips
                                                                    class="mb-4"
                                                                    deletable-chips
                                                                    hide-details
                                                                    multiple
                                                                    outlined
                                                                    @change="sortCurrentSelectedRule()"
                                                                    @focus="scrollDestDomainsToBottom($event)"
                                                                >
                                                                </v-combobox>
                                                                <!--                                                                <v-carousel
                                                                                                                                    height="auto"
                                                                                                                                    hide-delimiter-background
                                                                                                                                    hide-delimiters
                                                                                                                                    show-arrows-on-hover
                                                                                                                                >
                                                                                                                                    <template v-slot:prev="{ on, attrs }">
                                                                                                                                        <v-btn
                                                                                                                                            icon
                                                                                                                                            v-bind="attrs"
                                                                                                                                            v-on="on"
                                                                                                                                            x-small
                                                                                                                                        >
                                                                                                                                            <v-icon
                                                                                                                                                v-text="icons.mdiChevronLeftCircle"></v-icon>
                                                                                                                                        </v-btn>
                                                                                                                                    </template>
                                                                                                                                    <template v-slot:next="{ on, attrs }">
                                                                                                                                        <v-btn
                                                                                                                                            icon
                                                                                                                                            v-bind="attrs"
                                                                                                                                            v-on="on"
                                                                                                                                            x-small
                                                                                                                                        >
                                                                                                                                            <v-icon
                                                                                                                                                v-text="icons.mdiChevronRightCircle"></v-icon>
                                                                                                                                        </v-btn>

                                                                                                                                    </template>
                                                                                                                                    <v-carousel-item transition="fade-transition">
                                                                                                                                        <v-sheet color="grey" class="lighten-5 rounded">
                                                                                                                                            <div class="caption mb-6 mt-1 pa-2">
                                                                                                                                                <v-icon
                                                                                                                                                    v-text="icons.mdiInformationOutline"
                                                                                                                                                    small class="mr-1"></v-icon>
                                                                                                                                                *.openoffice.org is missing
                                                                                                                                                <span class="text-decoration-underline">required domains</span>
                                                                                                                                                <div>
                                                                                                                                                    <v-btn icon>
                                                                                                                                                        <v-icon small
                                                                                                                                                                v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                                                                                    </v-btn>
                                                                                                                                                </div>
                                                                                                                                            </div>
                                                                                                                                        </v-sheet>
                                                                                                                                    </v-carousel-item>
                                                                                                                                    <v-carousel-item transition="fade-transition">
                                                                                                                                        <v-sheet>
                                                                                                                                            <div class="caption mb-6 mt-1 pa-2">
                                                                                                                                                <v-icon
                                                                                                                                                    v-text="icons.mdiInformationOutline"
                                                                                                                                                    small class="mr-1"></v-icon>
                                                                                                                                                Lufthansa.com is missing
                                                                                                                                                <span class="text-decoration-underline">required domains</span>
                                                                                                                                                <div>
                                                                                                                                                    <v-btn icon>
                                                                                                                                                        <v-icon small
                                                                                                                                                                v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                                                                                    </v-btn>
                                                                                                                                                </div>
                                                                                                                                                &lt;!&ndash;                                                                                <v-btn x-small
                                                                                                                                                                                                                                       class="primary lighten-2 mx-1"
                                                                                                                                                                                                                                       rounded>Learn More
                                                                                                                                                                                                                                </v-btn>
                                                                                                                                                                                                                                <v-btn x-small
                                                                                                                                                                                                                                       class="primary lighten-2 mx-1"
                                                                                                                                                                                                                                       rounded>Add all domains as a
                                                                                                                                                                                                                                    Group
                                                                                                                                                                                                                                </v-btn>&ndash;&gt;
                                                                                                                                            </div>
                                                                                                                                        </v-sheet>
                                                                                                                                    </v-carousel-item>
                                                                                                                                </v-carousel>-->

                                                            </div>

                                                            <!--                                                            <v-textarea
                                                                                                                            outlined
                                                                                                                            :rows="currentSelectedRule.dest_domains.length"
                                                                                                                            @input="storeBackNewLinesAsArrayElement(currentSelectedRule.dest_domains, $event)"
                                                                                                                            :value="replaceCommaWithNewLineForArray(currentSelectedRule.dest_domains)"
                                                                                                                        ></v-textarea>-->

                                                            <!--                                                            :persistent-hint="(currentSelectedRule.dest_groups && currentSelectedRule.dest_groups.length > 0)"-->

                                                            <!--                                                                :items="(groups) ? groups : []"-->

                                                            <!-- TODO: where we select groups, add the possibility to select a “directory”. Example : if we have a directory Antivirus with inside several groups (Avast, Eset, Norton) instead of selecting each of them, just select “antivirus”. The display should show it is a directory and not a normal group.-->
                                                            <v-autocomplete
                                                                ref="internetFilterTabGroupsRef"
                                                                v-model="currentSelectedRule.dest_groups"
                                                                :append-outer-icon="icons.mdiOpenInNew"
                                                                :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                                :hide-details="ruleCompact"
                                                                :hint="$gettext('Please hover over the group name (long press for mobile) to display the domain(s) for the group.')"
                                                                :item-text="item => item.parent || item.group"
                                                                :item-value="item => item.parent ? item.parent +'/'+item.group : item.group"
                                                                :items="allGroupsForAutocomplete"
                                                                :label="$gettext('Groups')"
                                                                :small-chips="ruleCompact"
                                                                auto-select-first
                                                                chips
                                                                deletable-chips
                                                                multiple
                                                                outlined
                                                                @change="sortCurrentSelectedRule()"
                                                                @click:append-outer="openEditGroupsDialog"
                                                            >
                                                                <template v-slot:message="{ message, key }">
                                                                    <span v-html="message"></span>
                                                                    &nbsp;
                                                                    <a
                                                                        class='text-decoration-underline cursor-pointer'
                                                                        @click='addAGroup();'
                                                                        v-text="$gettext('Add a Group')">
                                                                    </a>
                                                                </template>

                                                                <template v-slot:selection="data">

                                                                    <v-tooltip color="primary" top>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <div
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                            >

                                                                                <v-chip
                                                                                    :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                                                    :input-value="data.selected"
                                                                                    :small="ruleCompact"
                                                                                    close
                                                                                    v-bind="data.attrs"
                                                                                    @click.stop="destGroupsClicked(data.item.parent, data.item.group) && data.select"
                                                                                    @click:close="removeDestGroup(data.item)"
                                                                                >
                                                                                    <v-icon
                                                                                        v-if="data.item.parent.length > 0"
                                                                                        class="primary--text mr-1"
                                                                                        small
                                                                                        v-text="icons.mdiFolder"
                                                                                    ></v-icon>
                                                                                    <span
                                                                                        v-if="data.item.parent.length > 0"
                                                                                        class="mr-1"
                                                                                        v-text="data.item.parent"></span>

                                                                                    <v-icon
                                                                                        v-if="data.item.parent.length > 0 && data.item.group"
                                                                                        class="primary&#45;&#45;text mr-1"
                                                                                        small
                                                                                        v-text="icons.mdiSlashForward">
                                                                                    </v-icon>

                                                                                    <v-icon
                                                                                        v-if="data.item.group"
                                                                                        class="primary--text mr-1"
                                                                                        small
                                                                                        v-text="icons.mdiSelectGroup"
                                                                                    ></v-icon>
                                                                                    {{ data.item.group }}
                                                                                </v-chip>
                                                                            </div>
                                                                        </template>
                                                                        <v-row>
                                                                            <v-col
                                                                                v-if="getDestDomainsForGroup(data.item.group, data.item.parent)?.length > 0"
                                                                                class="elevation-3 mb-4" cols="12">

                                                                                <p class="my-1 subtitle-1 font-weight-bold"
                                                                                   v-text="computedDomainPatternText(data)">
                                                                                </p>
                                                                                <v-divider class="mb-2"
                                                                                           color="white"></v-divider>

                                                                                <div
                                                                                    v-for="(d, index) in getDestDomainsForGroup(data.item.group, data.item.parent)">
                                                                                    <small v-if="d">{{ index + 1 }}.
                                                                                        {{ d }}</small>
                                                                                </div>
                                                                            </v-col>

                                                                            <v-col v-else-if="data.item.group"
                                                                                   class="mb-4" cols="12">
                                                                                {{
                                                                                    $gettextInterpolate($gettext('Sorry! %{ groupName }, contains no domain information yet.'), {groupName: data.item.group})
                                                                                }}
                                                                            </v-col>
                                                                            <v-col
                                                                                v-else-if="!data.item.group && data.item.parent"
                                                                                class="mb-4" cols="12">

                                                                                <!-- Show all groups inside this folder, in a simple csv -->
                                                                                <v-row>
                                                                                    <v-col cols="12">
                                                                                        <v-row>
                                                                                            <v-col cols="12">
                                                                                                <p class="my-1 subtitle-1 font-weight-bold"
                                                                                                   v-text="$gettext('Contains groups:')">
                                                                                                </p>
                                                                                            </v-col>
                                                                                        </v-row>


                                                                                        <v-divider class="mb-2"
                                                                                                   color="white"></v-divider>

                                                                                        <v-row>
                                                                                            <v-col cols="12">
                                                                                                <div
                                                                                                    v-for="(d, index) in getGroupsInsideFolder(data.item.parent)">
                                                                                                    <small v-if="d">{{
                                                                                                            index + 1
                                                                                                        }}.
                                                                                                        {{
                                                                                                            d.key
                                                                                                        }}</small>
                                                                                                </div>
                                                                                            </v-col>
                                                                                        </v-row>


                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-col>
                                                                        </v-row>


                                                                    </v-tooltip>
                                                                </template>

                                                                <template v-slot:item="{ props, item, on, attrs }">

                                                                    <!--<v-list-item
                                                                        :subtitle="item?.parent"
                                                                        :title="item?.group"
                                                                        class="ml-4"
                                                                        v-bind="props"
                                                                        v-on="on"
                                                                    >
                                                                        <v-list-item-content>
                                                                            <v-list-item-title>
                                                                                <v-icon small
                                                                                        v-text="icons.mdiSelectGroup"></v-icon>
                                                                                {{ item.group }}
                                                                            </v-list-item-title>
                                                                            <v-list-item-subtitle
                                                                                v-if="item.parent.length > 0"
                                                                                class="mute small">
                                                                                <v-icon small
                                                                                        v-text="icons.mdiFolderOutline"></v-icon>
                                                                                {{ item.parent }}
                                                                            </v-list-item-subtitle>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                    -->

                                                                    <v-list-item
                                                                        :subtitle="item?.parent"
                                                                        :title="item?.group"
                                                                        class="ml-4"
                                                                        dense
                                                                        v-bind="props"
                                                                        v-on="on"
                                                                        @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                    >
                                                                        <v-list-item-content
                                                                            :class="{'ml-4': item.group && item.parent}"
                                                                            @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                        >

                                                                            <!-- Group name -->
                                                                            <v-list-item-title
                                                                                v-if="item.group"
                                                                                class="d-flex"
                                                                                @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                            >
                                                                                <v-icon class="mr-2" small
                                                                                        v-text="icons.mdiSelectGroup"></v-icon>

                                                                                <!-- small text -->
                                                                                <span
                                                                                    class="text-caption text--lighten-2">
                                                                                    {{ item.group }}
                                                                                </span>

                                                                                <v-icon
                                                                                    v-if="isFolderOrGroupPresentInDestGroups(item.parent, item.group)"
                                                                                    class="ml-auto" small
                                                                                    style="width: auto;"
                                                                                    v-text="icons.mdiCheck"
                                                                                ></v-icon>
                                                                            </v-list-item-title>

                                                                            <!-- Folder name but does not have a group, so just the folder -->

                                                                            <v-list-item-subtitle
                                                                                v-if="item.parent.length > 0 && !item.group"
                                                                                class="d-flex"
                                                                                @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                            >
                                                                                <v-icon class="primary--text"
                                                                                        small
                                                                                        v-text="icons.mdiFolder"></v-icon>

                                                                                <span class="ml-2 body-2">{{
                                                                                        item.parent
                                                                                    }}</span>
                                                                                <v-icon
                                                                                    v-if="isFolderOrGroupPresentInDestGroups(item.parent)"
                                                                                    class="ml-auto darken-2"
                                                                                    small
                                                                                    v-text="icons.mdiCheck"></v-icon>

                                                                            </v-list-item-subtitle>
                                                                        </v-list-item-content>
                                                                    </v-list-item>

                                                                    <!-- Only loose group names not the groups inside the folder & the folder itself -->
                                                                    <!--                                                                    <v-list-item
                                                                                                                                            :subtitle="item?.parent"
                                                                                                                                            :title="item?.group"
                                                                                                                                            class="ml-4"
                                                                                                                                            v-bind="props"
                                                                                                                                            v-on="on"
                                                                                                                                            @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                                                                                        >
                                                                                                                                            <v-list-item-content
                                                                                                                                                :class="{'ml-4': item.group && item.parent}"
                                                                                                                                                @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                                                                                            >
                                                                                                                                                <v-list-item-title
                                                                                                                                                    v-if="item.group"
                                                                                                                                                    class="d-flex"
                                                                                                                                                    @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                                                                                                >
                                                                                                                                                    <v-icon small
                                                                                                                                                            v-text="icons.mdiSelectGroup"></v-icon>
                                                                                                                                                    <span class="small">
                                                                                                                                                        {{ item.group }}
                                                                                                                                                    </span>

                                                                                                                                                    <v-icon
                                                                                                                                                        v-if="isFolderOrGroupPresentInDestGroups(item.parent, item.group)"
                                                                                                                                                        class="ml-auto" small
                                                                                                                                                        style="width: auto;"
                                                                                                                                                        v-text="icons.mdiCheck"
                                                                                                                                                    ></v-icon>
                                                                                                                                                </v-list-item-title>
                                                                                                                                                &lt;!&ndash; Folder name but does not have a group, so just the folder &ndash;&gt;
                                                                                                                                                <v-list-item-subtitle
                                                                                                                                                    v-if="item.parent.length > 0 && !item.group"
                                                                                                                                                    class="d-flex"
                                                                                                                                                    @click.prevent.stop="insertIndividualGroupOrFolderIntoDestGroups(item.parent, item.group)"
                                                                                                                                                >
                                                                                                                                                    <v-icon small
                                                                                                                                                            v-text="icons.mdiFolderOutline"></v-icon>

                                                                                                                                                    <span class="ml-2 ">{{
                                                                                                                                                            item.parent
                                                                                                                                                        }}</span>
                                                                                                                                                    <v-icon
                                                                                                                                                        v-if="isFolderOrGroupPresentInDestGroups(item.parent)"
                                                                                                                                                        class="ml-auto darken-2"
                                                                                                                                                        small
                                                                                                                                                        v-text="icons.mdiCheck"></v-icon>
                                                                                                                                                </v-list-item-subtitle>
                                                                                                                                            </v-list-item-content>
                                                                                                                                        </v-list-item>-->
                                                                </template>


                                                            </v-autocomplete>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-tab-item>
                                                <v-tab-item
                                                    :key="1"
                                                    :value="1"
                                                >
                                                    <v-card flat>
                                                        <!--                                                        <v-card-text class="subtitle-1 text-center">-->

                                                        <v-card-title class="mb-3 justify-center">
                                                            <h3 class="d-flex align-center">
                                                                <!--                                                                    <v-img src="img/verify.png" width="32" class="mr-3" />-->
                                                                <v-icon class="mr-3" color="primary"
                                                                        lighten-1 x-large
                                                                        v-text="icons.mdiCheckDecagram"></v-icon>
                                                                {{ $gettext('Full Access') }}
                                                            </h3>
                                                        </v-card-title>
                                                        <v-card-subtitle class="mb-3">
                                                            {{
                                                                $gettext('The permission applies to the entire Internet.')
                                                            }}
                                                        </v-card-subtitle>
                                                        <!--                                                        </v-card-text>-->
                                                    </v-card>
                                                </v-tab-item>

                                            </v-tabs-items>

                                            <!-- todo: to be removed
                                            <v-row v-if="eitherCurrentSelectedRuleHasATimeConditionOrAQuota">
                                                <v-col class="text-right">
                                                    <v-btn-toggle
                                                        v-model="currentSelectedRule.is_time_conditions_or_quota"
                                                        class="mr-6 mt-2"
                                                        dense rounded>
                                                        <v-btn :value="1" class="primary--text" small>
                                                            <span class="mr-2">{{ $gettext('Time Conditions') }}</span>
                                                            <v-icon v-text="icons.mdiTimerOutline"></v-icon>
                                                        </v-btn>
                                                        <v-btn :value="2" class="primary--text" small>
                                                            <span class="mr-2">{{ $gettext('Quota') }}</span>
                                                            <v-icon v-text="icons.mdiChartPie"></v-icon>
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </v-col>
                                            </v-row>
                                            -->

                                            <!------------------------------------------------
                                                Time Conditions
                                            ------------------------------------------------->

                                            <v-row
                                                v-if="currentSelectedRule && currentSelectedRule.time_condition && typeof(currentSelectedRule.time_condition) === 'object' && currentSelectedRule.time_condition.length > 0"
                                                class="text-left mx-0">

                                                <v-col v-for="(tc, tcIndex) in currentSelectedRule.time_condition"
                                                       :key="tcIndex"
                                                       class="text-center" cols="12">

                                                    <v-hover v-slot="{ hover }">
                                                        <v-card :elevation="hover ? 5 : 1" rounded>
                                                            <v-card-text class="pb-0 time-condition-wrapper">
                                                                <v-btn v-for="(day, weekIndex) in weekdays"
                                                                       :key="weekIndex"
                                                                       :color="getIndividualDayDetails(weekIndex + 1, tc.days) ? 'primary': ''"
                                                                       :small="!ruleCompact"
                                                                       :x-small="ruleCompact"
                                                                       class="day-in-circle mx-1 subtitle-2"
                                                                       fab
                                                                       @click="toggleThisDayStatus(weekIndex + 1, tcIndex)"
                                                                >{{ day }}
                                                                </v-btn>
                                                                <v-divider
                                                                    :class="{'mt-5': !ruleCompact, 'mt-2': ruleCompact}"></v-divider>
                                                                <div
                                                                    class="subtitle-1 mt-1 d-flex justify-center align-center">
                                                                    <div class="pr-4 d-flex align-center" v-if="!currentSelectedRule.time_condition[tcIndex].hasOwnProperty('flexible') ||  !currentSelectedRule.time_condition[tcIndex]['flexible']">
                                                                        <v-icon class="my-2 mr-1 d-flex" color="primary"
                                                                                v-text="icons.mdiClock">
                                                                        </v-icon>
                                                                        {{ padStart(tc.from) }} - {{ padStart(tc.to) }}
                                                                    </div>
                                                                    <div v-else>
                                                                        <v-icon class="my-2 mr-1 d-flex" color="primary"
                                                                                v-text="icons.mdiChartPie">
                                                                        </v-icon>
                                                                        {{ tc.time_allowed + ' hours'
                                                                            }}
                                                                        {{ tc.weekly ? ' ' + $gettext('weekly') : $gettext('daily') }}
                                                                    </div>

                                                                    <!--                                                                    :label="(tc.strict_end === 1 || tc.strict_end === true) ? $gettext('Strict End') : $gettext('Not a Strict End')"-->

                                                                    <v-switch
                                                                        v-model="currentSelectedRule.time_condition[tcIndex]['strict_end']"
                                                                        :class="{'o-60': !currentSelectedRule.time_condition[tcIndex]['strict_end']}"
                                                                        :false-value="0"
                                                                        :label="$gettext('Strict End')"
                                                                        :true-value="1"
                                                                        class="d-flex mx-auto transition-ease-in-out"
                                                                        color="primary"
                                                                        dense
                                                                        inset
                                                                        @change="toggleStrictEnd(tc.strict_end)"
                                                                    ></v-switch>



                                                                    <!-- <v-icon class="my-2 ml-auto d-flex" color="primary" size="18"
                                                                            @click="openAddEditTimeConditionDialog('edit', tcIndex)">
                                                                        {{ icons.mdiPencil }}
                                                                    </v-icon>
                                                                    <v-icon class="my-2 mx-1 d-flex" color="primary" size="18" @click="deleteTimeCondition(tcIndex)">
                                                                        {{ icons.mdiDeleteForever }}
                                                                    </v-icon>-->

                                                                </div>

                                                                <div :class="{'pb-3': !ruleCompact}"
                                                                     class="d-flex justify-center align-center">

                                                                    <v-menu>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn icon plain v-bind="attrs" v-on="on">
                                                                                <v-icon
                                                                                    v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <v-list dense>
                                                                            <v-list-item
                                                                                class="cursor-pointer"
                                                                                @click="openAddEditTimeConditionDialog('add')">
                                                                                <v-list-item-title>
                                                                                    <v-btn class="mr-1" icon>
                                                                                        <v-icon
                                                                                            small
                                                                                            v-text="icons.mdiTimerPlusOutline"></v-icon>
                                                                                    </v-btn>
                                                                                    <span
                                                                                        v-text="$gettext('Add a Time Condition')"></span>
                                                                                </v-list-item-title>
                                                                            </v-list-item>
                                                                            <v-list-item
                                                                                class="cursor-pointer"
                                                                                @click="openAddEditTimeConditionDialog('edit', tcIndex)">
                                                                                <v-list-item-title>
                                                                                    <v-btn class="mr-1" icon>
                                                                                        <v-icon
                                                                                            small
                                                                                            v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                    </v-btn>
                                                                                    <span
                                                                                        v-text="$gettext('Edit')"></span>
                                                                                </v-list-item-title>
                                                                            </v-list-item>
                                                                            <v-list-item
                                                                                class="cursor-pointer"
                                                                                @click="deleteTimeCondition(tcIndex)">
                                                                                <v-list-item-title>
                                                                                    <v-btn class="mr-1" icon>
                                                                                        <v-icon
                                                                                            small
                                                                                            v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                    </v-btn>
                                                                                    <span
                                                                                        v-text="$gettext('Delete')"></span>
                                                                                </v-list-item-title>
                                                                            </v-list-item>
                                                                        </v-list>
                                                                    </v-menu>
                                                                </div>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-hover>
                                                </v-col>
                                            </v-row>
                                            <!--                                            <v-row
                                                                                            v-else-if="isATimeCondition && (eitherCurrentSelectedRuleHasATimeConditionOrAQuota)">
                                                                                            <v-col>
                                                                                                <p>{{ $gettext('No time conditions found.') }}</p>
                                                                                            </v-col>
                                                                                        </v-row>-->

                                            <!------------------------------------------------
                                                Quota
                                            ------------------------------------------------->

                                            <!--                                            <v-row
                                                                                            v-if="currentSelectedRule && currentSelectedRule.quota && typeof(currentSelectedRule.quota) === 'object'
                                                                                            && isAQuota"
                                                                                            class="text-left mx-0">
                                                                                            <v-col>
                                                                                                <v-card>
                                                                                                    <v-card-text>

                                                                                                        <v-row>
                                                                                                            <v-col>
                                                                                                                <v-icon class="my-2 mr-1" color="primary"
                                                                                                                        v-text="icons.mdiClockOutline"></v-icon>
                                                                                                                <span class="subtitle-1">{{
                                                                                                                        formattedDuration
                                                                                                                    }}</span>
                                                                                                            </v-col>
                                                                                                            <v-col class="text-right">
                                                                                                                <span
                                                                                                                    v-if="currentSelectedRule.quota.type === 'daily'"
                                                                                                                    class="subtitle-1">
                                                                                                                    {{ $gettext('Everyday') }}
                                                                                                                </span>
                                                                                                                <span
                                                                                                                    v-else-if="currentSelectedRule.quota.type === 'weekly'"
                                                                                                                    class="subtitle-1">
                                                                                                                    {{ $gettext('Every Week') }}
                                                                                                                </span>
                                                                                                            </v-col>
                                                                                                        </v-row>
                                                                                                        <div :class="{'pb-3': !ruleCompact}"
                                                                                                             class="d-flex justify-center align-center">

                                                                                                            <v-menu>
                                                                                                                <template v-slot:activator="{ on, attrs }">
                                                                                                                    <v-btn icon plain v-bind="attrs" v-on="on">
                                                                                                                        <v-icon
                                                                                                                            v-text="icons.mdiDotsHorizontal"></v-icon>
                                                                                                                    </v-btn>
                                                                                                                </template>
                                                                                                                <v-list dense>
                                                                                                                    <v-list-item
                                                                                                                        class="cursor-pointer"
                                                                                                                        @click="openAddEditTimeConditionDialog('add')">
                                                                                                                        <v-list-item-title>
                                                                                                                            <v-btn class="mr-1" icon>
                                                                                                                                <v-icon
                                                                                                                                    small
                                                                                                                                    v-text="icons.mdiTimerPlusOutline"></v-icon>
                                                                                                                            </v-btn>
                                                                                                                            <span
                                                                                                                                v-text="$gettext('Add a Time Condition')"></span>
                                                                                                                        </v-list-item-title>
                                                                                                                    </v-list-item>
                                                                                                                    <v-list-item
                                                                                                                        class="cursor-pointer"
                                                                                                                        @click="openAddEditTimeConditionDialog('edit')">
                                                                                                                        <v-list-item-title>
                                                                                                                            <v-btn class="mr-1" icon>
                                                                                                                                <v-icon
                                                                                                                                    small
                                                                                                                                    v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                                                            </v-btn>
                                                                                                                            <span
                                                                                                                                v-text="$gettext('Edit')"></span>
                                                                                                                        </v-list-item-title>
                                                                                                                    </v-list-item>
                                                                                                                    <v-list-item
                                                                                                                        class="cursor-pointer"
                                                                                                                        @click="deleteTimeCondition()">
                                                                                                                        <v-list-item-title>
                                                                                                                            <v-btn class="mr-1" icon>
                                                                                                                                <v-icon
                                                                                                                                    small
                                                                                                                                    v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                                                            </v-btn>
                                                                                                                            <span
                                                                                                                                v-text="$gettext('Delete')"></span>
                                                                                                                        </v-list-item-title>
                                                                                                                    </v-list-item>
                                                                                                                </v-list>
                                                                                                            </v-menu>
                                                                                                        </div>
                                                                                                    </v-card-text>
                                                                                                </v-card>
                                                                                            </v-col>
                                                                                        </v-row>-->
                                            <!-- TODO: to be removed
                                                             <v-row v-else-if="isAQuota">
                                                                                            <v-col>
                                                                                                <p>{{ $gettext('No quotas are assigned yet.') }}</p>
                                                                                            </v-col>
                                                                                        </v-row>-->


                                        </v-col>
                                        <!--<v-col md="3" class="pt-0">
                                                                                    <v-sheet>
                                                                                        <v-switch
                                                                                            v-model="currentSelectedRule.allow_deny"
                                                                                            inset
                                                                                            :label="currentSelectedRule.allow_deny == 1 ? 'Authorisation' : 'Prohibition'"
                                                                                        ></v-switch>
                                                                                    </v-sheet>
                                                                                </v-col>-->
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col :cols="layout === 'row' ? '12' : $vuetify.breakpoint.lgAndUp ? '6' : '12'">

                            <v-card :outlined="isDark" elevation="1">
                                <v-card-title>
                                    <div class="text-truncate"
                                         v-text="$gettextInterpolate($gettext('Users for %{ruleName}'), {ruleName: currentSelectedRuleKey})"></div>
                                    <div v-if="['1', 1].includes(currentSelectedRule.master)"
                                         class="caption text-left w-100">
                                        <v-icon class="mr-2" x-small v-text="icons.mdiLock"></v-icon>
                                        Managed by Organization
                                    </div>
                                </v-card-title>
                                <v-card-subtitle>
                                    <v-row>
                                        <v-col>
                                            <!--                                                      :label="currentSelectedRule.any_user === 0 ? $gettext('Listing') : $gettext('All')"-->
                                            <v-switch v-model="currentSelectedRule.any_user"
                                                      :class="{'o-60': currentSelectedRule.any_user === 0}"
                                                      :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                      :false-value="0"
                                                      :label="$gettext('All Users')"
                                                      :true-value="1"
                                                      class="mt-0 pt-0 font-weight-bold transition-ease-in-out"
                                            >
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                </v-card-subtitle>
                                <v-card-text>
                                    <v-row v-if="currentSelectedRule.any_user === 0">
                                        <v-col>
                                            <draggable v-model="currentSelectedRule.users"
                                                       :options="{disabled : $vuetify.breakpoint.smAndDown}"
                                                       group="addUser">
                                                <v-autocomplete
                                                    v-model="currentSelectedRule.users"
                                                    :append-outer-icon="icons.mdiOpenInNew"
                                                    :disabled="[1, '1'].includes(currentSelectedRule.master)"
                                                    :hide-details="ruleCompact"
                                                    :items="consolidatedUsersAndSubUsers"
                                                    :label="$gettext('Users')"
                                                    :small-chips="ruleCompact"
                                                    auto-select-first
                                                    chips
                                                    deletable-chips
                                                    multiple
                                                    outlined
                                                    @click:append-outer="openAddUserToRuleDialog()"
                                                ></v-autocomplete>
                                            </draggable>
                                        </v-col>
                                    </v-row>
                                    <v-row v-else-if="currentSelectedRule.any_user === 1">
                                        <v-col>
                                            <v-card flat>
                                                <!--                                                <v-card-text class="subtitle-1 text-center">-->


                                                <v-card-title class="mb-3 justify-center">
                                                    <h3 class="d-flex align-center">
                                                        <!--                                                                    <v-img src="img/verify.png" width="32" class="mr-3" />-->
                                                        <v-icon class="mr-3" color="primary"
                                                                lighten-1 x-large
                                                                v-text="icons.mdiCheckDecagram"></v-icon>
                                                        {{ $gettext('All Users') }}
                                                    </h3>
                                                </v-card-title>
                                                <v-card-subtitle class="mb-3">
                                                    {{ $gettext('This filter applies to all users.') }}
                                                </v-card-subtitle>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <!--        <v-row class="text-right">
                    <v-col>
                        <small v-text="'Rules: '+ currentViewRulesCount()"></small>
                    </v-col>
                </v-row>-->

        <!------------------------------------------------
            Dialogs
        ------------------------------------------------->

        <!--        current-selected-rule="currentSelectedRule"-->

        <dialog-add-edit-rule
            v-if="addEditRuleDialog"
            :add-edit-rule-dialog="addEditRuleDialog"
            :in-edit-rule-name="editRuleNameField"
            :mode="addEditRuleMode"
            :rules-prop="rules"
            @close-add-edit-rule-dialog="(dialogName) => { closeDialog(dialogName) }"
            @rule-added="(ruleToSave) => { processAddARule(ruleToSave) }"
            @rule-updated="(ruleToUpdate) => { processEditARule(ruleToUpdate) }"
        >
        </dialog-add-edit-rule>

        <v-dialog
            v-model="editGroupsDialog"
            fullscreen
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >
                    <span class="text-truncate">
                    {{
                            $gettextInterpolate($gettext('Edit Groups for %{ ruleName }'), {ruleName: currentSelectedRuleKey})
                        }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" v-text="icons.mdiClose" @click.native.stop="closeEditGroupsDialog()"></v-icon>
                </v-toolbar>
                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>
                        <v-row v-if="currentSelectedRule">

                            <!------------------------------------------------
                                Left panel (for desktop, on mobile this is second) offering of the choice of folders and groups (that are not already in dest_groups)
                            ------------------------------------------------->

                            <v-col cols="12" md="6">
                                <div
                                    :class="{'text-h5': $vuetify.breakpoint.mdAndUp, 'text-h6': $vuetify.breakpoint.smAndDown}"
                                    class="pb-3"
                                    v-text="$gettext('All Groups')"></div>

                                <v-divider class="mb-4"/>

                                <!--                                <v-list
                                                                    :class="{'height-60-vh': $vuetify.breakpoint.mdAndUp, 'height-30-vh': $vuetify.breakpoint.smAndDown}"
                                                                    class="overflow-x-auto">
                                                                    <div v-for="(group) in groups" v-if="showUniqueGroupsForGroupsDialog(group)"
                                                                         :key="group.key">

                                                                        <v-list-group v-if="group.hasOwnProperty('child')">

                                                                            <template v-slot:activator>
                                                                                <v-list-item-title class="text-left align-center d-flex">
                                                                                    {{ group.key }}
                                                                                </v-list-item-title>
                                                                            </template>

                                                                            <div v-for="groupChild in group.child"
                                                                                 v-if="showUniqueGroupsForGroupsDialog(groupChild, group.key)"
                                                                                 class="text-left ml-8 mb-2">
                                                                                <v-list-item>
                                                                                    <v-list-item-content class="cursor-pointer"
                                                                                                         @click="insertGroup(groupChild.key, group.key)"
                                                                                                         v-text="groupChild.key">
                                                                                    </v-list-item-content>
                                                                                </v-list-item>
                                                                            </div>
                                                                            <div v-if="hasNoGroupChildForGroupsDialog(group)" class="ml-6 mb-3">
                                                                                {{ $gettext('No groups are available for this folder.') }}
                                                                            </div>

                                                                        </v-list-group>

                                                                        <v-list-item-group v-else>
                                                                            <v-list-item>
                                                                                <v-list-item-content class="cursor-pointer"
                                                                                                     @click="insertGroup(group.key)"
                                                                                                     v-text="group.key">
                                                                                </v-list-item-content>
                                                                            </v-list-item>
                                                                        </v-list-item-group>

                                                                    </div>
                                                                </v-list>-->


                                <!--                                {{ currentSelectedRule.dest_groups }}-->

                                <!-- Have new v-list just like above just ensure that even folder can be selected, instead of collapse and expand. -->
                                <v-list class="overflow-x-auto">

                                    <v-list-item v-for="(group) in groups"
                                                 v-if="showUniqueGroupsAndFolderForGroupsDialog(group)"
                                                 :key="group.key"
                                                 dense style="min-height: 30px;">

                                        <div v-if="group.hasOwnProperty('child')" class="w-100">

                                            <!------------------------------------------------
                                                Folder
                                            ------------------------------------------------->

                                            <v-row
                                                class="text-left align-center d-flex cursor-pointer"
                                                @click="insertGroup('', group.key)">

                                                <v-col class="py-2" cols="9" md="10">
                                                    <v-icon class="mr-2 primary--text"
                                                            v-text="editGroupDialogOpenFolders.indexOf(group.key) !== -1 ? icons.mdiFolderOpen : icons.mdiFolder"></v-icon>
                                                    {{ group.key }}
                                                </v-col>
                                                <v-col class="text-right py-2">
                                                    <span :title="$gettext('Click to toggle visibility')"
                                                          class="caption"
                                                          @click.prevent.stop="toggleEditGroupDialogOpenFolders(group.key)">

<!--                                                        {{-->
                                                        <!--                                                            group.child.length-->
                                                        <!--                                                        }}-->

                                                        <!--                                                        {{
                                                                                                                    group.child.length > 1 ? $gettext('groups') : $gettext('group')
                                                                                                                }}-->

                                                        <v-icon class="mr-0" v-text="icons.mdiSelectGroup"></v-icon> {{
                                                            group.child.length
                                                        }}



                                                    </span>
                                                </v-col>
                                            </v-row>

                                            <!------------------------------------------------
                                                Loop over each folder for groups
                                            ------------------------------------------------->

                                            <v-list v-if="group.child.length > 0" class="py-1 my-1" dense>

                                                <v-list-item v-for="groupChild in group.child"
                                                             v-if="showUniqueGroupsForGroupsDialog(groupChild, group.key) && editGroupDialogOpenFolders.indexOf(group.key) !== -1"
                                                             class="text-left mb-0 pb-0"
                                                             dense
                                                             style="min-height: 24px;">

                                                    <v-list-item-content>
                                                        <v-list-item-title class="cursor-pointer"
                                                                           @click="insertGroup(groupChild.key, group.key)"
                                                        >
                                                            <v-icon class="mr-1" small
                                                                    v-text="icons.mdiSelectGroup"></v-icon>
                                                            {{ groupChild.key }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <!--                                                <div v-if="hasNoGroupChildForGroupsDialog(group)" class="ml-6 mb-3">
                                                                                                    {{ '' }}
                                                                                                </div>-->
                                            </v-list>
                                            <div v-else class="py-1 my-1">
                                                <!-- Keep this for equal spacing-->
                                            </div>

                                        </div>

                                        <div v-else>
                                            <div class="cursor-pointer"
                                                 @click="insertGroup(group.key)">
                                                <v-icon class="mr-1" small v-text="icons.mdiSelectGroup"></v-icon>
                                                {{ group.key }}
                                            </div>
                                        </div>

                                    </v-list-item>

                                </v-list>

                                <!-- No records message -->
                                <div v-if="!hasVisibleGroups">
                                    {{ $gettext('No groups are available for selection.') }}
                                </div>
                            </v-col>

                            <!------------------------------------------------
                                The right panel, the selection of folders and groups
                            ------------------------------------------------->

                            <v-col :class="{'order-first': $vuetify.breakpoint.smAndDown}" cols="12" md="6">
                                <div
                                    :class="{'text-h5': $vuetify.breakpoint.mdAndUp, 'text-h6': $vuetify.breakpoint.smAndDown}"
                                    class="pb-3"
                                    v-text="$gettext('Chosen Groups')"></div>
                                <v-divider/>
                                <!--                                    :class="{'height-60-vh': $vuetify.breakpoint.mdAndUp, 'height-30-vh': $vuetify.breakpoint.smAndDown}"-->
                                <v-list
                                    class="overflow-x-auto">
                                    <v-list-item-group
                                        v-if="currentSelectedRule && currentSelectedRule.dest_groups && currentSelectedRule.dest_groups?.length > 0">
                                        <draggable v-model="currentSelectedRule.dest_groups"
                                                   :options="{disabled : $vuetify.breakpoint.smAndDown}"
                                                   group="addGroup">
                                            <v-list-item v-for="(group, groupKey) in currentSelectedRule.dest_groups"
                                                         :key="groupKey">
                                                <v-list-item-content>
                                                    <span v-if="group.indexOf('/') !== -1">
                                                        <v-icon class="mr-1 primary--text" small
                                                                v-text="icons.mdiFolder"></v-icon>
                                                        {{ group.split('/')[0] }}
                                                        <v-icon v-if="group.split('/')[1]"
                                                                class="mr-1 primary--text" small
                                                                v-text="icons.mdiSlashForward"></v-icon>
                                                        <v-icon v-if="group.split('/')[1]"
                                                                class="mr-1 primary--text" small
                                                                v-text="icons.mdiSelectGroup"></v-icon>
                                                        {{ group.split('/')[1] }}
                                                    </span>
                                                    <span v-else>
                                                        <v-icon class="mr-1 primary--text" small
                                                                v-text="icons.mdiSelectGroup"></v-icon>
                                                        {{ group }}
                                                    </span>
                                                </v-list-item-content>
                                                <v-list-item-icon>
                                                    <v-icon small @click="deleteEditGroups(group)"
                                                            v-text="icons.mdiDeleteForever"></v-icon>
                                                </v-list-item-icon>
                                            </v-list-item>
                                        </draggable>
                                    </v-list-item-group>
                                    <v-list-item-group v-else>
                                        <v-list-item>
                                            <v-list-item-content
                                                v-text="$gettext('No groups chosen yet.')"></v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <!--                <v-divider></v-divider>-->

                <!--                <v-card-actions fixed>-->
                <!--                    <span class="text-subtitle-2 font-weight-light">{{-->
                <!--                            $gettext('Available Groups:')-->
                <!--                        }} {{ totalGroupsCount() }} </span>-->
                <!--                    <span-->
                <!--                        v-if="currentSelectedRule && currentSelectedRule.hasOwnProperty('dest_groups') && currentSelectedRule.dest_groups"-->
                <!--                        class="text-subtitle-2 font-weight-light">&nbsp;|&nbsp; Chosen Groups: {{-->
                <!--                            currentSelectedRule.dest_groups.length-->
                <!--                        }}</span>-->
                <!--                    <v-spacer></v-spacer>-->
                <!--                    <v-btn-->
                <!--                        color="primary"-->
                <!--                        @click.native.stop="closeEditGroupsDialog()"-->
                <!--                    >-->
                <!--                        {{ $gettext('Close') }}-->
                <!--                    </v-btn>-->
                <!--                </v-card-actions>-->
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="addUserToRuleDialog"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >{{
                        $gettextInterpolate($gettext('Manage User(s) for %{ currentSelectedRule }'), {currentSelectedRule: currentSelectedRuleKey})
                    }}
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddUserToRuleDialog()">{{ icons.mdiClose }}</v-icon>
                </v-toolbar>
                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>

                        <v-row v-if="currentSelectedRule">
                            <v-col>
                                <div
                                    :class="{'text-h5': $vuetify.breakpoint.mdAndUp, 'text-h6': $vuetify.breakpoint.smAndDown}"
                                    class="pb-3 secondary--text">
                                    {{ $gettext('All Users') }}
                                    <!--  The autocomplete loads but filter is yet to be done -->
                                    <!-- <v-autocomplete
                                        ref="userSearch"
                                        append-icon="mdi-magnify"
                                        v-model="userAutoCompleteFilterValue2"
                                        :items="prepareAnArrayForAutocompleteTopLevel(users)"
                                        label="Narrow down to a User"
                                        clearable
                                        autofocus
                                    ></v-autocomplete>-->
                                </div>
                                <v-divider/>

                                <v-list
                                    :class="{'height-60-vh': $vuetify.breakpoint.mdAndUp, 'height-30-vh': $vuetify.breakpoint.smAndDown}"
                                    class="overflow-x-auto">

                                    <v-list-group v-for="(category, categoryKey) in users"
                                                  :key="categoryKey"
                                                  class="user-listing"
                                                  no-action
                                    >
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <v-list-item-title class="text-h6"
                                                                   v-text="category.key"></v-list-item-title>
                                            </v-list-item-content>
                                        </template>

                                        <v-list-item v-for="(user) in category.value"
                                                     v-if="!['@_internet', '@_categories_profile'].includes(user.key)"
                                                     :key="user.key"
                                                     class="pl-4"
                                        >
                                            <v-list-item-content class="py-2 mb-auto">
                                                <v-list-item-title class="user-cursor-pointer"
                                                                   @click="insertUserToRule(user.key)">
                                                    <v-icon v-text="icons.mdiAccountCircle"></v-icon>
                                                    {{ user.key }}
                                                </v-list-item-title>
                                            </v-list-item-content>

                                            <v-list-item-group v-if="user.value.subusers?.length > 0">
                                                <v-list-item v-for="(subUser) in user.value.subusers" :key="subUser.key"
                                                             class="pl-4"
                                                             dense
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title
                                                            class="user-cursor-pointer"
                                                            @click="insertUserToRule(subUser.key)">
                                                            <v-icon class="mr-2"
                                                                    v-text="icons.mdiAccountChildCircle"></v-icon>
                                                            <span class="subtitle-2" v-text="subUser.key"></span>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list-item-group>

                                        </v-list-item>

                                    </v-list-group>

                                </v-list>
                            </v-col>
                            <v-col :class="{'order-first': $vuetify.breakpoint.smAndDown}">
                                <div
                                    :class="{'text-h5': $vuetify.breakpoint.mdAndUp, 'text-h6': $vuetify.breakpoint.smAndDown}"
                                    class="pb-3 secondary--text">
                                    {{ $gettext('Chosen User(s)') }}
                                </div>
                                <v-divider/>
                                <v-list
                                    :class="{'height-60-vh': $vuetify.breakpoint.mdAndUp, 'height-30-vh': $vuetify.breakpoint.smAndDown}"
                                    class="overflow-x-auto">
                                    <v-list-item-group
                                        v-if="currentSelectedRule && currentSelectedRule.users && currentSelectedRule.users.length > 0"
                                        class="chosen-user-delete-icon">
                                        <draggable v-model="currentSelectedRule.users"
                                                   :options="{disabled : $vuetify.breakpoint.smAndDown}"
                                                   group="addUser">
                                            <v-list-item v-for="(user, userKey) in currentSelectedRule.users"
                                                         :key="userKey">
                                                <v-list-item-content class="py-2" v-text="user">
                                                </v-list-item-content>
                                                <v-list-item-icon>
                                                    <v-icon v-text="icons.mdiDeleteForever"
                                                            @click.native.stop="deleteUserForRule(user)"></v-icon>
                                                </v-list-item-icon>
                                            </v-list-item>
                                        </draggable>
                                    </v-list-item-group>
                                    <v-list-item-group v-else>
                                        <v-list-item>
                                            <v-list-item-content>
                                                {{ $gettext('No user chosen yet.') }}
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions fixed>
                    <span
                        v-if="currentSelectedRule && currentSelectedRule.hasOwnProperty('users') && currentSelectedRule.users"
                        class="text-subtitle-2 font-weight-light">Chosen {{
                            $gettext('Users:')
                        }} {{
                            currentSelectedRule.users.length
                        }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click.native.stop="closeAddUserToRuleDialog()"
                    >
                        {{ $gettext('Close') }}
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <dialog-add-edit-time-condition
            v-if="addEditTimeConditionDialog"
            :params="addEditTimeConditionParams">
        </dialog-add-edit-time-condition>


        <!------------------------------------------------
            Snackbar
        ------------------------------------------------->

        <snackbar ref="snackbar"></snackbar>

        <!------------------------------------------------
            Bottom Sheet
        ------------------------------------------------->

        <div class="text-center">
            <v-bottom-sheet v-model="keyboardOptionsBottomSheet" inset>
                <v-card tile>
                    <v-progress-linear
                        :value="100"
                        class="my-0"
                        height="3"
                    ></v-progress-linear>

                    <v-row class="px-5 py-2">
                        <v-col>

                            <!-- autofocus-->
                            <v-autocomplete
                                v-model="keyboardOptionsAutocomplete"
                                :items="keyboardOptionsAutocompleteOptions"
                                append-icon="mdi-magnify"
                                auto-select-first
                                item-color="primary"
                                item-text="text"
                                item-value="value"
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card>
            </v-bottom-sheet>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import draggable from 'vuedraggable'
import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinConfig from '@/mixins/database/MixinConfig'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinConfigRules from '@/mixins/database/MixinConfigRules'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinListing from '@/mixins/listing/MixinListing'
import DialogInternetFilterAddEditRule from '@/components/dialogs/internet_filters_tab/DialogInternetFilterAddEditRule'
import DialogInternetFilterAddEditTimeCondition
    from '@/components/dialogs/internet_filters_tab/DialogInternetFilterAddEditTimeCondition'
import {useGroupsStore} from '@/stores/GroupsStore'
import {mapState, mapWritableState} from 'pinia'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import {useRulesStore} from '@/stores/RulesStore'
import MixinLodashPadStart from '@/mixins/lodash/MixinLodashPadStart'
import {useConnectionsStore} from '@/stores/ConnectionsStore'
import MixinTranslation from '@/mixins/translation/MixinTranslation'
import {findIndex, isArray} from "lodash";
import smoothScrollIntoView from "smooth-scroll-into-view-if-needed";
import Constants from "@/assets/js/constants";
import RulesNoMatchingSearchResult from "@/components/blocks/RulesNoMatchingSearchResult.vue";
import IconsMaster from "@/components/blocks/icons/IconsMaster.vue";
import constants from "@/assets/js/constants";

Vue.use(VueSweetalert2)

export default {
    name: 'InternetFilterTab',
    components: {
        IconsMaster,
        RulesNoMatchingSearchResult,
        draggable,
        DialogAddEditRule: DialogInternetFilterAddEditRule,
        Snackbar,
        DialogAddEditTimeCondition: DialogInternetFilterAddEditTimeCondition
    },
    mixins: [MixinDialog, MixinIcon, MixinConfig, MixinConfigUsers, MixinConfigRules, MixinSwalConfirmation, MixinStringManipulation, MixinListing, MixinGenericComponent, MixinLodashPadStart, MixinTranslation],
    data() {
        return {
            rulesListItem: '',

            addEditTimeConditionParams: [],
            addEditTimeConditionDialog: false,

            addEditRuleMode: 'add',
            editRuleNameField: '',

            dbRules: [],

            userAutoCompleteFilterValue2: '',

            addUserToRuleDialog: false,

            editGroupsDialog: false,

            keyboardOptionsBottomSheet: false,
            keyboardOptionsAutocomplete: '',
            keyboardOptionsAutocompleteOptions: [
                {
                    text: 'Compact',
                    value: 'c'
                },
                {
                    text: 'Expand',
                    value: 'e'
                },
                {
                    text: 'Layout',
                    value: 'l'
                },
                {
                    text: 'Add Rule',
                    value: 'a'
                },
            ],

            addTimeConditionDays: [],

            addScheduleFrom: '',
            addScheduleTo: '',

            weekdays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],

            currentFilterMode: 'all',
            ruleFilterConditions: [],
            isShowFilter: false,

            addRuleName: '',
            addEditRuleDialog: false,
            addRuleAnyUser: '',
            addRuleAllowDeny: '',
            addRuleAnyDestination: '',

            layout: 'column',
            userPanel: '',
            permissionPanel: '',
            ruleCompact: false,
            userTab: null,
            /**
             * Represents the currently selected rule.
             *
             * @type {string}
             * Structure:
             *
             * { "any_user": 0, "any_destination": 0, "allow_deny": 1, "active": "on", "time_condition": "", "comments": "", "users": [ "Priyank" ], "dest_groups": [ "Atlassian Products/Atlassian.net Group", "technic" ], "dest_domains": [ "laravel.com", "www.laravel.com" ], "strict_end": 0 }
             *
             */
            currentSelectedRule: '',
            currentSelectedRuleKey: '',
            isShowSearch: false,
            ruleFilterValue: '',

            editUserDialog: false,

            selectedChildUser: '',
            categoryName: '',
            userName: '',

            /**
             * Array to store all groups for autocomplete functionality.
             *
             * @type {Array}
             */
            allGroupsForAutocomplete: [],

            showMoreSearchFields: false,
            visibleRules: [],
            allDomainsForVisibleRules: [],
            domainFilter: '',

            /**
             * This array variable keeps track of all the open folder state for the left side column for the Dialog Edit Groups
             */
            editGroupDialogOpenFolders: []
        }
    },

    mounted() {

        const self = this

        /*let rulesStore = useRulesStore();
        let {rules} = storeToRefs(rulesStore);
        self.rules = rules;

        let usersStore = useUsersStore();
        let {users} = storeToRefs(usersStore);
        self.users = users;

        let groupsStore = useGroupsStore();
        let {groups} = storeToRefs(groupsStore);

        self.groups = groups.value;*/

        self.setHeightForListingBox()

        /* Disabled for now
        window.addEventListener('keydown', (e) => {

            if (e.key === '/') {
                self.keyboardOptionsBottomSheet = true
            }
            if (e.ctrlKey && e.key === 'e' && self.currentSelectedRule) {
                self.openAddEditRuleDialog(self.currentSelectedRuleKey, 'edit')
            }
            if (e.ctrlKey && e.key === 'x' && self.currentSelectedRule) {
                self.deleteRule(self.currentSelectedRuleKey)
            }
            if (e.ctrlKey && e.key === 'u' && self.currentSelectedRule) {
                self.toggleAnyUser(self.currentSelectedRule)
            }
            if (e.ctrlKey && e.key === 'd' && self.currentSelectedRule) {
                self.toggleAnyDestination(self.currentSelectedRule)
            }
            if (e.ctrlKey && e.key === 'p' && self.currentSelectedRule) {
                self.toggleAllowDeny(self.currentSelectedRule)
            }

        }) */

        self.subscribeToGroupsStoreAndGetChangesForAllGroupsForAutocomplete();
        self.readAndSetRuleCompactFromLocalStorage();
        self.readAndSetLayoutFromLocalStorage();

        self.setVisibleRules();

    },
    watch: {

        userAutoCompleteFilterValue2: {

            handler: function (val) {

                let self = this
                self.setVisibleRules();

            },
            deep: true
        },

        layout(newVal, oldVal) {

            let self = this

            try {
                localStorage.setItem(Constants.localStorageInternetFilterTabLayout, newVal)
            } catch (e) {
                // console.log(e)
            }

        },

        ruleCompact(newVal, oldVal) {


            let self = this

            try {
                localStorage.setItem(Constants.localStorageInternetFilterTabRuleCompact, newVal)
            } catch (e) {
                // console.log(e)
            }

        },

        /* This and linked functions are kept for now. Can be used in the future.
        userAutoCompleteFilterValue2: {
                    handler: function (val, oldVal) {
                        let self = this
                        self.filteredUsersWithKeyValue()
                    },
                    deep: true
                }, */
        keyboardOptionsAutocomplete(newVal) {

            let self = this

            switch (newVal) {

                case 'e': {
                    self.ruleCompact = false
                    self.keyboardOptionsBottomSheet = false
                    break
                }

                case 'c': {
                    self.ruleCompact = true
                    self.keyboardOptionsBottomSheet = false
                    break
                }

                case 'l': {
                    self.toggleLayout()
                    self.keyboardOptionsBottomSheet = false
                    break
                }

                case 'a': {
                    self.openAddEditRuleDialog('', 'add')
                    self.keyboardOptionsBottomSheet = false
                    break
                }

            }

            if (newVal && newVal !== 'a') {
                self.closeDialog('addEditRuleDialog')
            }

            self.$nextTick(function () {
                self.keyboardOptionsAutocomplete = ''
            })

        },

        ruleFilterValue: {
            handler: function () {
                const self = this
                self.userPanel = []
            },
            deep: true
        },

        currentSelectedRule: {

            handler: function (rule) {

                let self = this

                self.$nextTick(function () {

                    let index = findIndex(rule, function (o) {
                        return o.key === self.currentSelectedRuleKey
                    })

                    if (index > -1) {

                        self.rules[index] = {
                            key: self.currentSelectedRuleKey,
                            value: rule
                        }

                    }

                })

                self.$emit('update:currentSelectedRule', rule)

            },
            deep: true
        },
        currentSelectedRuleKey: {
            handler: function (val) {
                let self = this

                self.$emit('update:currentSelectedRuleKey', val)
            },
            deep: true
        },
        isShowFilter: {
            handler: function (val) {
                let self = this

                self.$emit('update:isShowFilter', val)
            },
        },
        currentFilterMode: {
            handler: function (val) {
                let self = this

                self.$emit('update:currentFilterMode', val)
            },
        }
    },

    computed: {
        ...mapWritableState(useRulesStore, {
            rules: 'rules',
        }),
        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
        }),
        ...mapState(useConnectionsStore, {
            currentConnection: 'currentConnection',
        }),
        /**
         * Checks if there any visible groups.
         * This is mainly used to show a no records message when no groups are available for selection.
         * This is used in the Edit Groups dialog (fullscreen).
         *
         * @returns {boolean} - True if there are groups available for selection, false otherwise.
         */
        hasVisibleGroups() {
            return this.groups.some(group => this.showUniqueGroupsAndFolderForGroupsDialog(group));
        },
        isMdAndUpOrOnTheMobileListingPage() {
            return (this.$vuetify.breakpoint.mdAndUp || (this.$vuetify.breakpoint.smAndDown && (!this.currentSelectedRule || this.currentSelectedRule.length === 0)))
        },
        currentSelectedRuleHasAllowDeny1() {
            return (this.currentSelectedRule && this.currentSelectedRule.hasOwnProperty('allow_deny') && this.currentSelectedRule.allow_deny === 1)
        },
        haveUsers() {

            let self = this

            let haveRecords = true

            if (self.userAutoCompleteFilterValue2?.length > 0) {

                haveRecords = false

                self.users.forEach((category) => {
                    category?.value.forEach((user) => {
                        if (user?.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase())) {
                            haveRecords = true
                        }
                    })
                })

                if (!haveRecords) {

                    self.users.forEach((category) => {
                        category.value.forEach((user) => {
                            user.value.subusers?.forEach((subuser) => {
                                if (subuser.key.toLowerCase().includes(self.userAutoCompleteFilterValue2.toLowerCase())) {
                                    haveRecords = true
                                }
                            })
                        })
                    })

                }

            } else if (self.users.length === 0) {
                haveRecords = false
            }

            return haveRecords

        },
        formattedDuration() {
            const hours = Math.floor(this.currentSelectedRule?.quota?.duration / 60);
            const minutes = this.currentSelectedRule?.quota?.duration % 60;
            return `${hours} hours ${minutes} minutes`;
        },
        /* Todo: to be removed
        isATimeCondition() {
            return this.currentSelectedRule?.hasOwnProperty('is_time_conditions_or_quota') && this.currentSelectedRule?.is_time_conditions_or_quota === 1
        },
        isAQuota() {
            return this.currentSelectedRule?.hasOwnProperty('is_time_conditions_or_quota') && this.currentSelectedRule?.is_time_conditions_or_quota === 2
        },
        eitherCurrentSelectedRuleHasATimeConditionOrAQuota() {
            return this.currentSelectedRule.time_condition || this.currentSelectedRule.quota
        },
         */
    },
    methods: {

        toggleEditGroupDialogOpenFolders(folderName) {

            let self = this;

            if (self.editGroupDialogOpenFolders.indexOf(folderName) === -1) {
                self.editGroupDialogOpenFolders.push(folderName)
            } else {
                self.editGroupDialogOpenFolders.splice(self.editGroupDialogOpenFolders.indexOf(folderName), 1)
            }

            return false;

        },

        folderHasOneOrMoreRulesNotPresentInDestGroups(folderName) {

            let self = this
            let group = self.groups.find(g => g.key === folderName);

            if (group) {
                if (group.hasOwnProperty('child')) {
                    return group.child.some(child => {
                        return !self.isGroupWithFolderPresentInDestGroups(child.key, folderName)
                    })
                }
            }

            return false


        },

        getGroupsInsideFolder(folderName) {

            let self = this
            let group = self.groups.find(g => g.key === folderName);

            if (group) {
                if (group.hasOwnProperty('child')) {
                    return group.child
                }
            }

            return []

        },

        isFolderOrGroupPresentInDestGroups(folder = false, group = false) {

            let self = this;

            if (folder && !group) {
                // return self.isFolderAndAllGroupsInsideArePresentInDestGroups(folder)
                return self.isFolderPresentInDestGroups(folder + '/')
            } else if (folder && group) {
                return self.isGroupWithFolderPresentInDestGroups(group, folder)
            } else if (group) {
                return self.isGroupWithoutFolderPresentInDestGroups(group)
            }

        },

        /**
         * Checks if a folder is present in the destination groups of the current selected rule.
         *
         * @param {string} folderName - The name of the folder to check.
         * @returns {boolean} - Returns true if the folder is present in the destination groups, otherwise returns false.
         */
        isFolderPresentInDestGroups(folderName) {

            let self = this;
            return self.currentSelectedRule.dest_groups?.includes(folderName)

        },

        isFolderAndAllGroupsInsideArePresentInDestGroups(folderName) {

            let self = this;
            // Check if all the groups that are inside this folder are present in the dest_groups
            let group = self.groups.find(g => g.key === folderName);

            if (group) {
                if (group.hasOwnProperty('child')) {
                    return group.child.every(child => {
                        return self.isGroupWithFolderPresentInDestGroups(child.key, folderName)
                    })
                }
            }

            return false;

        },

        isGroupWithFolderPresentInDestGroups(groupName, folderName) {

            let self = this;
            let r = self.currentSelectedRule?.dest_groups?.includes(`${folderName}/${groupName}`)
            return r

        },

        isGroupWithoutFolderPresentInDestGroups(groupName) {

            let self = this;
            return self.currentSelectedRule?.dest_groups?.includes(groupName)

        },

        /**
         *
         * Inserts an individual group or folder into destination groups.
         *
         * @param {string} folderName - (New)  (old) The name of the folder to be inserted. If provided, all children of this folder will be inserted into destination groups.
         * @param {string} groupName - The name of the group to be inserted.
         *
         * @return {void}
         */
        insertIndividualGroupOrFolderIntoDestGroups(folderName, groupName) {

            let self = this;

            // Toggle the group or folder i.e. if present remove them, if not present add them

            if (folderName) {
                // self.insertAllChildrenOfThisFolderIntoDestGroups(folderName)
                /*if (self.isFolderOrGroupPresentInDestGroups(folderName, groupName)) {
                    self.removeGroupOrFolder(groupName, folderName)
                } else {
                }*/

                // Have the toggle functionality here
                if (self.isFolderOrGroupPresentInDestGroups(folderName, groupName)) {
                    self.removeGroupOrFolder(groupName, folderName)
                } else {
                    self.insertGroup(groupName, folderName)
                }

            } else {
                /*if (self.isFolderOrGroupPresentInDestGroups(false, groupName)) {
                    self.removeGroupOrFolder(groupName)
                } else {
                }*/
                self.insertGroup(groupName)
            }

        },

        /**
         * Inserts all the children of the given folder into the destination groups.
         * @param {string} folderName - The name of the folder.
         * @returns {void}
         */
        insertAllChildrenOfThisFolderIntoDestGroups(folderName) {

            let self = this;
            let group = self.groups.find(g => g.key === folderName);

            if (group) {
                if (group.hasOwnProperty('child')) {
                    group.child.forEach(child => {
                        self.insertGroup(child.key, folderName)
                    })
                }
            }

        },

        sortCurrentSelectedRule() {

            let self = this;

            // sort but not in lexicographical way
            self.currentSelectedRule.dest_domains.sort((a, b) => a.localeCompare(b, undefined, {
                sensitivity: 'base'
            }))

            /*self.currentSelectedRule.dest_groups.sort((a, b) => a.localeCompare(b, undefined, {
                sensitivity: 'base'
            }))*/

            // Sort self.currentSelectedRule.dest_groups in such a way that folders come first and then groups
            self.currentSelectedRule.dest_groups?.sort((a, b) => {

                if (a.indexOf('/') !== -1 && b.indexOf('/') === -1) {
                    return -1
                } else if (a.indexOf('/') === -1 && b.indexOf('/') !== -1) {
                    return 1
                } else {
                    return a.localeCompare(b, undefined, {
                        sensitivity: 'base'
                    })
                }

            })

        },

        setAllDomainsForVisibleRules() {

            let self = this;
            self.allDomainsForVisibleRules = [];

            self.visibleRules.forEach(rule => {

                // remove empty entries
                if (rule.value.dest_domains) {
                    rule.value.dest_domains = rule.value.dest_domains.filter(domain => domain.length > 0);
                    self.$set(self, 'allDomainsForVisibleRules', self.allDomainsForVisibleRules.concat(rule.value.dest_domains))
                }

            })

        },

        setVisibleRules() {

            const self = this;

            self.visibleRules = JSON.parse(JSON.stringify(self.rules));

            // use checkEachRule
            self.visibleRules = self.visibleRules.filter(rule => {
                return self.checkEachRule(rule);
            });

            self.setAllDomainsForVisibleRules();

        },

        toggleShowMoreSearchFields() {
            this.showMoreSearchFields = !this.showMoreSearchFields
        },

        /**
         *
         * This function must return Array as the caller code is programmed to expect an array.
         *
         * @returns {Array}
         * @param userKey
         */
        allTheRulesThatAreApplicableToUser(userKey) {
            const rules = this.rules.filter(rule => (rule?.value?.any_user === 1 || rule?.value?.users?.includes(userKey)))
            return (isArray(rules) && rules.length > 0) ? rules : []
        },
        readAndSetRuleCompactFromLocalStorage() {

            let self = this;

            try {
                let val = localStorage.getItem(Constants.localStorageInternetFilterTabRuleCompact)
                if (val && val === 'true') {
                    self.ruleCompact = true
                } else {
                    self.ruleCompact = false
                }
            } catch (e) {
                // console.log(e)
                // TODO: Handle this
            }

        },
        readAndSetLayoutFromLocalStorage() {

            let self = this;

            try {
                let val = localStorage.getItem(Constants.localStorageInternetFilterTabLayout)
                if (val && val === 'row') {
                    self.layout = 'row'
                } else {
                    self.layout = 'column'
                }
            } catch (e) {
                // console.log(e)
            }
        },
        totalGroupsCount() {

            let self = this;
            let count = 0;

            self.groups.forEach(g => {
                if (g.hasOwnProperty('child')) {
                    g.child.forEach(gc => {
                        count++;
                    })
                } else {
                    count++
                }
            })

            return count;

        },

        /**
         * Checks if the given group doesn't have any child groups for a groups dialog.
         *
         * @param {object} group - The group object to be checked.
         * @returns {boolean} Returns true if the given group has no child groups for a groups dialog, false otherwise.
         */
        hasNoGroupChildForGroupsDialog(group) {

            let self = this;
            let hasNoGroupForChild = true;
            let folderName = group.key;

            group.child.forEach(g => {
                if (self.showUniqueGroupsForGroupsDialog(g, folderName) && hasNoGroupForChild) {
                    hasNoGroupForChild = false;
                }
            })

            return hasNoGroupForChild;

        },

        showUniqueGroupsForGroupsDialog(group, folder = false) {

            let self = this;

            let fullGroupNameWithFolderNameIfApplicable = folder ? `${folder}/${group.key}` : group.key;

            if (!self.currentSelectedRule || !self.currentSelectedRule.dest_groups) {
                return true;
            }

            return !self.currentSelectedRule.dest_groups?.includes(fullGroupNameWithFolderNameIfApplicable);

        },


        /**
         *
         * Displays a unique groups and folder dialog for the given group.
         * This is used to ensure that the groups and folders shown in selection (to choose) are unique.
         *
         * If a folder is selected, we will not display it's child groups as the folder selection means all the child groups are selected as well.
         *
         * Another thing to note, this is called on all items, folders as well as groups
         *
         * @param {Object} group - The group structure is {key: key, value: value, child:...}.
         * @returns {boolean} - Returns true if the folder/group is to be shown, false otherwise.
         */
        showUniqueGroupsAndFolderForGroupsDialog(group = '') {

            let self = this;
            let folderName = '';

            if (group.hasOwnProperty('child')) {
                folderName = group.key;
            }

            if (folderName) {
                // return !self.isFolderOrGroupPresentInDestGroups(group.key) || self.folderHasOneOrMoreRulesNotPresentInDestGroups(group.key)
                // If folder is present in dest domains, then return false
                return !self.isFolderPresentInDestGroups(folderName + '/')
            }

            return self.showUniqueGroupsForGroupsDialog(group)

        },

        computedDomainPatternText(data) {

            let folderName = data.item.parent ? `${data.item.parent}/` : '';
            let groupName = data.item.group;

            return this.$gettextInterpolate(
                this.$gettext('Domain patterns for %{folderName}%{ groupName }'),
                {folderName, groupName}
            )

        },

        getDestDomainsForGroup(groupName, folderName = false) {


            let r = [];
            let groupKey = folderName || groupName;
            let group = this.groups.find(g => g.key === groupKey);

            if (group) {

                if (folderName) {

                    let child = group.child.find(c => c.key === groupName);

                    if (child) {
                        r = child.value.dest_domains;
                    }

                } else {
                    r = group.value.dest_domains;
                }
            }

            return r;

        },

        subscribeToGroupsStoreAndGetChangesForAllGroupsForAutocomplete() {

            let self = this;

            useGroupsStore().$subscribe((mutation, state) => {
                self.setAllGroupsForAutocomplete();
            })

            self.setAllGroupsForAutocomplete();

        },

        setAllGroupsForAutocomplete() {

            const parentGroupObj = (parent, group) => ({parent, group});

            /*
            this.allGroupsForAutocomplete = this.groups.flatMap(value => {
                if (value.hasOwnProperty('child')) {
                    return value.child.map(childValue => {
                        return parentGroupObj(value.key, childValue.key)
                    });
                } else {
                    return parentGroupObj(false, value.key);
                }
            }); */


            // TODO: where we select groups, add the possibility to select a “directory”. Example : if we have a directory Antivirus with inside several groups (Avast, Eset, Norton) instead of selecting each of them, just select “antivirus”. The display should show it is a directory and not a normal group.-->
            // So, add a directory as an entry as well for allGroupsForAutocomplete


            this.allGroupsForAutocomplete = this.groups.flatMap(value => {
                if (value.hasOwnProperty('child')) {
                    let childs = value.child.map(childValue => {
                        return parentGroupObj(value.key, childValue.key)
                    });
                    return [parentGroupObj(value.key, ''), ...childs];
                } else {
                    return parentGroupObj(false, value.key);
                }
            });


            // New: We should only show directory, and hide any groups that are inside that dir, and in addition to that we can have loose groups.
            /*this.allGroupsForAutocomplete = this.groups.flatMap(value => {
                if (value.hasOwnProperty('child')) {
                    return parentGroupObj(value.key, '');
                } else {
                    return parentGroupObj(false, value.key);
                }
            });*/


        },

        scrollDestDomainsToBottom(el) {

            el = document.querySelector('#destDomainsWrapper')

            if (el) {

                let rectangleCordinates = el.getBoundingClientRect()
                // window.scrollTo(0, rectangleCordinates.height);

                jQuery('html, body').animate({
                    scrollTop: rectangleCordinates.height
                }, 0)

            }

        },

        replaceCommaWithNewLineForArray(str) {
            return str.toString().replaceAll(',', '\n')
        },

        storeBackNewLinesAsArrayElement(element, str) {

            let self = this
            self.currentSelectedRule.dest_domains = str.replaceAll('\n', ',').split(',')

        },

        /**
         * This considers search parameter/filter as well
         * @returns {boolean}
         */
        currentViewRulesCount() {

            let self = this

            let ruleCount = 0

            if (self.rules.length > 0) {

                self.rules.forEach((rule) => {
                    this.checkEachRule(rule) ? ruleCount++ : ''
                })

            }

            return ruleCount
        },

        removeDestGroup(item) {
            const index = this.currentSelectedRule.dest_groups?.indexOf(item.parent ? item.parent + '/' + item.group : item.group)
            if (index >= 0) this.currentSelectedRule.dest_groups?.splice(index, 1)
        },

        addAGroup() {

            let self = this
            let homeComponent = self.genericComponentGetComponent('Home')
            homeComponent.currentTab = constants.groupsTabIndex

            // Because if the dropdown is open, we want to close it when the user clicks on a group.
            self.$refs.internetFilterTabGroupsRef.blur()

            // Why the nextTick? Because, when if the groups tab is not selected so far, the groupstabref would not be available until that tab is selected.
            self.$nextTick(function () {

                setTimeout(function () {
                    homeComponent.$refs.groupsTabRef.openAddEditGroupDialog('', 'add')
                }, 100)

            })

        },

        /**
         *
         * Takes the user to the groups tab
         *
         * @param folder
         * @param group
         */
        async destGroupsClicked(folder, group = false) {

            let self = this;

            let homeComponent = self.genericComponentGetComponent('Home')
            homeComponent.currentTab = constants.groupsTabIndex

            // Because if the dropdown is open, we want to close it when the user clicks on a group.
            self.$refs.internetFilterTabGroupsRef.blur()

            // Why the nextTick? Because, when if the groups tab is not selected so far, the groupstabref would not be available until that tab is selected.
            await self.$nextTick()
            await self.$nextTick()
            await self.$nextTick() // Two were absolutely required on the dev, third is for the safety net

            let groupRow = false;

            if (folder && folder.length > 0) {

                groupRow = self.groups.find(g => g.key === folder);

                if (groupRow && group) {
                    let childRow = groupRow.child.find(c => c.key === group);

                    if (childRow) {
                        groupRow = childRow;
                    }
                }

            } else {
                groupRow = self.groups.find(g => g.key === group);
            }

            if (groupRow) {

                homeComponent.$refs.groupsTabRef.syncFolderGroups();
                homeComponent.$refs.groupsTabRef.clearCurrentSelectedGroup();

                for (let i in homeComponent.$refs.groupsTabRef.groupFolderListing) {
                    homeComponent.$refs.groupsTabRef.groupFolderListing[i]['open'] = false;
                }

                await self.$nextTick()

                if (group) { // Because if only folder selection is applicable then this might not be required
                    homeComponent.$refs.groupsTabRef.selectGroup(groupRow.key, groupRow.value);
                }

                if (folder && folder.length > 0) {
                    await self.$nextTick()
                    await self.$nextTick() // One is required, two is for safety net
                    homeComponent.$refs.groupsTabRef.groupFolderListing[folder]['open'] = true;
                }

                if (group) { // Because if only folder selection is applicable then this might not be required

                    homeComponent.$refs.groupsTabRef.comingFrom = 'internetFilterTab'

                    // This will run on the groups page and do the trick for us :)
                    setTimeout(() => {
                        smoothScrollIntoView(document.querySelector('.groups-tab-list .v-item--active'), {behavior: 'smooth'})
                    }, 300)

                }
            }


        },

        ruleIsMaster(rule) {
            return (rule && rule.hasOwnProperty('value') && rule.value && rule.value.hasOwnProperty('master') && [1, "1"].includes(rule.value.master));
        },

        ruleTextColorClasses(rule) {

            if (rule && rule.hasOwnProperty('value') && rule.value && rule.value.hasOwnProperty('active') && rule.value.active && rule.value.active.toLowerCase() === 'off') {
                return {'grey--text lighten-2': true}
            }

            if (rule && rule.hasOwnProperty('value') && rule.value && rule.value.hasOwnProperty('allow_deny') && rule.value.allow_deny === 1) {

                if (rule.value.any_user === 1) {
                    return {'green--text': true, 'font-weight-black': true}
                } else {
                    return {'green--text': true}
                }

            } else {

                if (rule.value?.any_destination === 0 && rule.value?.any_user === 1) {
                    return {'orange--text': true, 'font-weight-black': true}
                } else if (rule.value?.any_destination === 0) {
                    return {'orange--text': true}
                }

                if (rule.value.any_user === 1) {
                    return {'red--text': true, 'font-weight-black': true}

                } else {
                    return {'red--text': true}

                }

            }

        },

        /**
         * Opens the add/edit time condition dialog.
         *
         * tcIndex won't be given in the case of quota edit.
         *
         * @param {string} mode - The mode of the dialog. Can be 'add' or 'edit'.
         * @param {number} [tcIndex=undefined] - The index of the time condition.
         * @returns {boolean} - Returns false.
         */
        openAddEditTimeConditionDialog(mode, tcIndex = undefined) {

            let self = this
            let currentTimeCondition = false

            if (typeof tcIndex !== 'undefined') {

                let ruleIndex = findIndex(self.rules, {key: self.currentSelectedRuleKey})

                if (ruleIndex !== -1) {
                    currentTimeCondition = self.rules[ruleIndex]['value']['time_condition'][tcIndex]
                } else {
                    // TODO: Log error
                }

            } else if (mode === 'edit') {

                let ruleIndex = findIndex(self.rules, {key: self.currentSelectedRuleKey})

                if (ruleIndex !== -1) {
                    currentTimeCondition = self.isATimeCondition ? self.rules[ruleIndex]['value']['time_condition'] : self.rules[ruleIndex]['value']['quota']
                } else {
                    // TODO: Log error
                }

            }

            self.addEditTimeConditionParams = {
                addEditTimeConditionDialog: true,
                mode,
                tcIndex,
                ruleKey: self.currentSelectedRuleKey,
                currentTimeCondition
            }

            // self.setFieldsForAddEditTimeConditionDialog(parentCategory, parentUser, deviceName, mode)
            // self.refreshParamsForAddEditDeviceDialog(mac, active)

            self.addEditTimeConditionDialog = true

            return false
        },

        deleteRule(ruleKey) {

            let self = this

            let deleteRule = function (self) {

                let index = findIndex(self.rules, val => val.key === ruleKey)

                if (index !== -1) {

                    // This is a solution to a bit of an edge case scenario.
                    // If the searched user is deleted, we want to reset the search.
                    /*if (self.ruleFilterValue === ruleKey) {
                        // Why are we resetting? Because if the searched element is deleted. The search field should then be reset.
                        self.ruleFilterValue = ''
                    }*/

                    if (self.userAutoCompleteFilterValue2 === ruleKey) {
                        // Why are we resetting? Because if the searched element is deleted. The search field should then be reset.
                        self.userAutoCompleteFilterValue2 = ''
                    }

                    self.rules.splice(index, 1)

                    return true
                }

                return false

            }

            let swalOptions = {
                title: self.$gettext('Delete Rule'),
                description: self.$gettextInterpolate(self.$gettext('Are you sure, you want to delete the rule %{rule}?'), {rule: ruleKey}),
                successCallback: deleteRule,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: self.$gettext('Yes, delete it!'),
                successText: self.$gettext('Rule Deleted Successfully!')
            }

            self.swalConfirmation(swalOptions)

        },

        processEditARule(newRuleName) {

            let self = this
            self.$refs.snackbar.showSnackbar(self.$gettext('Rule updated successfully'))
            self.replaceTheRuleKeyWith(self.editRuleNameField, newRuleName)

            /*if (self.ruleFilterValue === self.editRuleNameField) {
                self.ruleFilterValue = newRuleName
            }*/

            if (self.userAutoCompleteFilterValue2 === self.editRuleNameField) {
                self.userAutoCompleteFilterValue2 = newRuleName
            }

        },

        processAddARule(ruleToSave) {

            let self = this

            self.selectRule(ruleToSave.key, ruleToSave.value)
            self.rules.push(ruleToSave)

            /*if (self.ruleFilterValue) {
                // self.ruleFilterValue = ruleToSave
                self.ruleFilterValue = '' // just clearing for now
            }*/

            if (self.userAutoCompleteFilterValue2) {
                // self.ruleFilterValue = ruleToSave
                self.userAutoCompleteFilterValue2 = '' // just clearing for now
            }

            self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Rule added successfully. Please manage the permissions and users for %{ rule }'), {rule: ruleToSave.key}))

        },

        deleteUserForRule(user) {

            let self = this
            self.currentSelectedRule.users.splice(self.currentSelectedRule.users.indexOf(user), 1)

        },
        insertUserToRule(userKey) {

            let self = this

            if (self.currentSelectedRule) {
                // Because from db it is null and we can't push on null
                if (!self.currentSelectedRule.users) {
                    self.currentSelectedRule.users = []
                }

                if (self.currentSelectedRule.users.indexOf(userKey) === -1) {
                    self.currentSelectedRule.users.push(userKey)
                }
            }

        },

        closeAddUserToRuleDialog() {

            let self = this
            self.addUserToRuleDialog = false

        },

        openAddUserToRuleDialog() {

            let self = this
            self.addUserToRuleDialog = true

        },

        deleteEditGroups(group) {

            let self = this
            self.currentSelectedRule.dest_groups?.splice(self.currentSelectedRule.dest_groups?.indexOf(group), 1)

        },


        /**
         *
         * Removes a group or folder from the list of destination groups of the current selected rule.
         *
         * @param {string|false} [groupKey=false] - The key of the group to be removed.
         * @param {boolean} [folder=false] - If true, the specified groupKey is treated as a folder to be removed.
         *
         * @return {void}
         */
        removeGroupOrFolder(groupKey = false, folder = false) {

            let self = this

            if (folder && !groupKey) {
                self.currentSelectedRule.dest_groups = self.currentSelectedRule.dest_groups?.filter(g => g !== `${folder}/`)
            } else if (folder && groupKey) {
                self.currentSelectedRule.dest_groups = self.currentSelectedRule.dest_groups?.filter(g => g !== `${folder}/${groupKey}`)
            } else {
                self.currentSelectedRule.dest_groups = self.currentSelectedRule.dest_groups?.filter(g => g !== groupKey)
            }

        },

        /**
         * Insert a group key into the current selected rule's destination groups.
         *
         * @param {string} groupKey - The group key to be inserted.
         * @param {string|boolean} folder - Optional The name of the folder or false if no folder is specified.
         */
        insertGroup(groupKey = false, folder = false) {

            let self = this

            if (self.currentSelectedRule) {

                // Because from db it is null, and we can't push on null
                if (!self.currentSelectedRule.dest_groups) {
                    self.currentSelectedRule.dest_groups = []
                }

                // helps with unique check
                const groupKeyWithFolder = folder ? `${folder}/${groupKey}` : groupKey;
                // const groupOrFolder = folder ? `${folder}/` : groupKey;

                if (self.currentSelectedRule.dest_groups.indexOf(groupKeyWithFolder) === -1) {
                    self.currentSelectedRule.dest_groups.push(groupKeyWithFolder)
                }

                self.$nextTick(() => {
                    self.sortCurrentSelectedRule();
                })

            }

        },

        closeEditGroupsDialog() {

            let self = this
            self.editGroupsDialog = false

        },

        openEditGroupsDialog() {

            let self = this
            self.editGroupsDialog = true

        },

        ruleSelectedForMobile() {
            let self = this

            return (
                self.$vuetify.breakpoint.smAndUp

                ||

                (self.$vuetify.breakpoint.mobile && !self.currentSelectedRuleKey)
            )
        },

        deleteTimeCondition(tcIndex = '') {

            let self = this

            let deleteTimeCondition = function (self) {
                self.deleteTheTimeCondition(self.currentSelectedRuleKey, tcIndex)
                return false
            }

            let deleteQuota = function (self) {
                self.deleteTheQuota(self.currentSelectedRuleKey)
                return false
            }

            let swalOptions = {
                title: self.$gettext('Deleting Time Condition'),
                description: self.$gettext('Are you sure, you want to delete this time condition?'),
                successCallback: deleteTimeCondition,
                /* todo: delete this
                successCallback: self.isATimeCondition ? deleteTimeCondition : (self.isAQuota ? deleteQuota : ''),
                 */
                icon: 'warning',
                confirmButtonText: self.$gettext('Yes, delete it!'),
                successText: self.$gettext('Time Condition Deleted Successfully!')
            }

            self.swalConfirmation(swalOptions)

        },

        getIndividualDayDetails(day, tc) {

            let found = false

            if (tc && tc.length > 0) {

                let pieces = tc.split(' ')

                if (pieces[0].indexOf(day) >= 0) {
                    found = true
                }

                /* works perfectly but did it another way.
                 let endPosition = string.indexOf(' ')

                if (endPosition && _.isInteger(endPosition)) {
                    // endPosition -= 1
                    let scheduleString = string.substring(0, endPosition)
                    if (scheduleString.indexOf(day) >= 0) {
                        found = true
                    }
                } */
            }

            return found

        },

        /** was required for older format, to be deleted soon
         getTimingsFromTimeCondition (tc) {

         if (typeof tc != 'undefined' && tc && tc.length > 0) {

         if (tc.indexOf(' ') !== -1) {
         let pieces = tc.split(' ')

         if (pieces[1].length > 0) {

         if (pieces[1].indexOf('-') !== -1) {
         let fromAndTo = pieces[1].split('-')
         return `${fromAndTo[0]} to ${fromAndTo[1]}`
         }

         }
         }

         }

         },
         */
        toggleStrictEnd(val) {

            if (val === 1) {
                return 0
            }

            return 1

        },


        toggleThisDayStatus(weekIndex, tcIndex) {

            let self = this

            let tc = self.currentSelectedRule.time_condition[tcIndex]

            if (tc) {

                if (tc.days.includes(weekIndex)) {
                    tc.days = tc.days.replaceAll(weekIndex, '')
                } else {
                    tc.days += tc.days + weekIndex
                }

                tc.days = tc.days.split('').filter(function (item, pos, self) {
                    return self.indexOf(item) === pos;
                }).join('')

                tc.days = tc.days.split('').sort().join('')
                // self.currentSelectedRule.time_condition[tcIndex]

            }

        },

        checkEachRule(rule) {

            let self = this
            let ruleVisibility = true

            /*---------------------------------------------
                    Filter based on search users
            ----------------------------------------------*/

            // now show only rules that are applicable to the user, if the user is selected, based on userAutoCompleteFilterValue2 using allTheRulesThatAreApplicableToUser method

            if (ruleVisibility && self.userAutoCompleteFilterValue2?.length > 0) {
                ruleVisibility = self.allTheRulesThatAreApplicableToUser(self.userAutoCompleteFilterValue2).includes(rule)
            }

            if (self.showMoreSearchFields && ruleVisibility) {

                /*---------------------------------------------
                    Filter based on rule name
                ----------------------------------------------*/

                if (self.ruleFilterValue && self.ruleFilterValue.length > 0) {
                    ruleVisibility = rule.key.toLowerCase().indexOf(self.ruleFilterValue.toLowerCase()) > -1;
                }


                /*---------------------------------------------
                    Filter based on search domains
                ----------------------------------------------*/

                if (ruleVisibility && self.domainFilter?.length > 0) {
                    ruleVisibility = rule.value.dest_domains?.includes(self.domainFilter)
                }

            }


            /*---------------------------------------------
                    Filter based on Active/Inactive/All
                ----------------------------------------------*/

            if (ruleVisibility && (self.ruleFilterConditions && self.ruleFilterConditions.length > 0)) {

                ruleVisibility = _.some(self.ruleFilterConditions, function (condition) {

                    let found = false

                    for (const [key] of Object.entries(condition)) {

                        if (rule.value[key] === condition[key]) {
                            found = true
                        }
                    }

                    return found

                })

            }

            return ruleVisibility

        },

        pushAFilterRule(ruleToAdd, mode) {
            const self = this

            self.removeAllFilters()
            if (ruleToAdd) {
                self.ruleFilterConditions.push(ruleToAdd)
            }
            self.currentFilterMode = mode
        },
        removeAllFilters() {
            let self = this
            self.ruleFilterConditions = []
        },
        toggleFilter() {
            let self = this
            self.isShowFilter = !self.isShowFilter
        },
        toggleAnyUser(rule) {

            if (rule.any_user === 0) {
                rule.any_user = 1
            } else {
                rule.any_user = 0
            }

            return rule

        },
        toggleAnyDestination(rule) {

            if (rule?.any_destination === 0) {
                rule.any_destination = 1
            } else {
                rule.any_destination = 0
            }

            return rule

        },
        toggleAllowDeny(rule) {

            if (rule && rule.hasOwnProperty('allow_deny') && rule.allow_deny === 0) {
                rule.allow_deny = 1
            } else {
                rule.allow_deny = 0
            }

            return rule

        },
        openAddEditRuleDialog(ruleName, mode) {
            const self = this
            self.addEditRuleDialog = true
            self.addEditRuleMode = mode

            self.editRuleNameField = ruleName

        },
        toggleLayout() {
            const self = this
            if (self.layout === 'row') {
                self.layout = 'column'
            } else if (self.layout === 'column') {
                self.layout = 'row'
            }
        },
        markRuleCompact(val) {
            const self = this
            self.ruleCompact = val
        },
        clearCurrentSelectedRule() {
            let self = this
            self.currentSelectedRule = ''
            self.currentSelectedRuleKey = ''
            self.userPanel = ''
            self.permissionPanel = ''
        },
        selectRule(ruleKey, ruleValue) {

            const self = this
            self.currentSelectedRuleKey = ruleKey
            self.currentSelectedRule = ruleValue

            self.permissionPanel = 0
            self.userPanel = 0

        },

        showSearch() {
            const self = this
            self.isShowSearch = true
            this.$refs.ruleSearch.focus()
        },
        toggleSearch() {
            const self = this
            self.isShowSearch = !self.isShowSearch
        },

    }
}
</script>

<style type="text/scss">
.user-count {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    background-color: white;
    border: 1px solid #e0e0e0;
    color: grey;
}

.max-height-50vh {
    max-height: 50vh;
}

.border-right-divider {
    border-right: 1px solid #e0e0e0;
}

.custom-green-chip {
    background-color: #00591c;
    color: white !important;
    padding: 4px 12px !important;
    border-radius: 16px;
}

.v-expansion-panel-header {
    padding-top: 8px;
    padding-bottom: 8px;
}

.chosen-user-delete-icon .v-list-item__icon {
    margin: 10px 0;
}

.user-cursor-pointer {
    cursor: pointer;
}

.height-30-vh {
    height: 30vh;
}

.height-60-vh {
    height: 60vh;
}

.height-70-vh {
    height: 70vh;
}


.v-expansion-panel-content__wrap {
    /* default padding: 0 24px 16px;*/
    padding: 5px 12px;
}

.current-selected-rule {
    /*background-color: #CCC !important;*/
    /*border: 1px solid red;*/
}

.user-listing .v-list-item, .chosen-user-delete-icon .v-list-item {
    min-height: 42px;
}

.rule-checkbox .v-icon.v-icon {
    font-size: 20px;
}

.add-border-list-on-small-devices {
    border-bottom: 2px solid #eeeeeea6;
    padding-top: 5px;
    padding-bottom: 5px;
}

.v-list-wrapper {
    overflow-y: auto;
}

.internet-filter-user-icon .v-list-item__icon {
    align-self: center;
}

.internet-filter-expansion .v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 40px;
}

.internet-filter-list-item .v-list-item {
    min-height: 35px;
}

.internet-filter-content-header-block {
    background-color: #d4dbde !important;
    border-color: #607d8b !important;
}


@media (max-width: 600px) {
    .internet-filter-expansion .v-btn--fab.v-size--small {
        height: 30px;
        width: 30px;
    }

    .internet-filter-expansion span.v-btn__content {
        font-size: 13px;
    }
}

.day-in-circle {
    height: 32px !important;
    width: 32px !important;

}

.rule-name {
    transition: all 0.3s;
}

</style>

